/* Consented Finder telemetry through Shopify's existing signed app proxy. */
;(function (w, d) {
  if (w.DelugsFinderAnalytics) return;
  var pending = [];
  function allowed() {
    try { return w.Shopify && w.Shopify.customerPrivacy && w.Shopify.customerPrivacy.analyticsProcessingAllowed() === true; }
    catch (e) { return false; }
  }
  function finish(item) {
    item.cancelled = true;
    if (item.timer) w.clearTimeout(item.timer);
    if (item.timeout) w.clearTimeout(item.timeout);
    var index = pending.indexOf(item);
    if (index !== -1) pending.splice(index, 1);
  }
  function clear() {
    pending.slice().forEach(function (item) {
      finish(item);
      if (item.controller) item.controller.abort();
    });
  }
  function receiptId() {
    try {
      if (w.crypto && typeof w.crypto.randomUUID === 'function') return w.crypto.randomUUID();
      if (!w.crypto || typeof w.crypto.getRandomValues !== 'function') return null;
      var bytes = new Uint8Array(16);
      w.crypto.getRandomValues(bytes);
      bytes[6] = (bytes[6] & 15) | 64;
      bytes[8] = (bytes[8] & 63) | 128;
      var hex = Array.prototype.map.call(bytes, function (value) { return ('0' + value.toString(16)).slice(-2); }).join('');
      return hex.slice(0, 8) + '-' + hex.slice(8, 12) + '-' + hex.slice(12, 16) + '-' + hex.slice(16, 20) + '-' + hex.slice(20);
    } catch (e) { return null; }
  }
  function attempt(item) {
    if (item.cancelled) return;
    if (!allowed()) { clear(); return; }
    item.attempts++;
    item.controller = new w.AbortController();
    item.timeout = w.setTimeout(function () { item.controller.abort(); }, 10000);
    var retry = false;
    Promise.resolve().then(function () {
      if (item.cancelled || !allowed()) { clear(); return; }
      return w.fetch('/apps/bespoke/analytics/finder-events', {
        method: 'POST', credentials: 'same-origin', cache: 'no-store', keepalive: true,
        signal: item.controller.signal,
        headers: { 'Content-Type': 'application/json', 'X-Delugs-Customer': '1' },
        body: item.body
      });
    }).then(function (response) {
      retry = !!response && !response.ok && [400, 401, 403, 404, 413, 422].indexOf(response.status) === -1;
    }).catch(function () { retry = true; }).then(function () {
      if (item.timeout) w.clearTimeout(item.timeout);
      if (item.cancelled) return;
      if (!allowed()) { clear(); return; }
      if (retry && item.attempts < 3) item.timer = w.setTimeout(function () { attempt(item); }, item.attempts * 750);
      else finish(item);
    });
  }
  function send(value) {
    try {
      if (!allowed() || typeof w.fetch !== 'function' || typeof w.AbortController !== 'function') return;
      var id = receiptId();
      if (!id || !/^[a-f0-9]{8}-[a-f0-9]{4}-4[a-f0-9]{3}-[89ab][a-f0-9]{3}-[a-f0-9]{12}$/i.test(id)) return;
      // Keep the same immutable receipt and payload on retry. No customer ID,
      // client timestamp or arbitrary property crosses this boundary.
      var payload = { consent: true, eventId: id, eventType: value.eventType, sessionId: value.sessionId,
        brand: value.brand, collection: value.collection, reference: value.reference,
        pageType: value.pageType, referrer: value.referrer, strap: value.strap,
        searchQuery: value.searchQuery, resultCount: value.resultCount };
      if (pending.length >= 32) return;
      var item = { body: JSON.stringify(payload), attempts: 0, cancelled: false };
      pending.push(item);
      attempt(item);
    } catch (e) { /* Optional telemetry never interrupts the Finder. */ }
  }
  w.DelugsFinderAnalytics = { allowed: allowed, send: send };
  d.addEventListener('visitorConsentCollected', function () { if (!allowed()) clear(); });
  // Load only Shopify's existing consent API. Do not queue pre-consent events.
  try { if (w.Shopify && w.Shopify.loadFeatures) w.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function () {}); }
  catch (e) {}
})(window, document);

// Exact catalogue identity aliases, approved 2 October 2026. Historical identifiers and URLs stay intact.
var sfCatalogueIdentityAliases = [
  {
    "reference": "SPB117J1",
    "from": {
      "brand": "Seiko",
      "collection": "Prospex"
    },
    "to": {
      "brand": "Seiko",
      "collection": "Alpinist"
    }
  },
  {
    "reference": "SPB155",
    "from": {
      "brand": "Seiko",
      "collection": "Prospex"
    },
    "to": {
      "brand": "Seiko",
      "collection": "Alpinist"
    }
  },
  {
    "reference": "SPB155J1",
    "from": {
      "brand": "Seiko",
      "collection": "Prospex"
    },
    "to": {
      "brand": "Seiko",
      "collection": "Alpinist"
    }
  },
  {
    "reference": "SPB377J1",
    "from": {
      "brand": "Seiko",
      "collection": "Prospex"
    },
    "to": {
      "brand": "Seiko",
      "collection": "Alpinist"
    }
  },
  {
    "reference": "SPB379J1",
    "from": {
      "brand": "Seiko",
      "collection": "Prospex"
    },
    "to": {
      "brand": "Seiko",
      "collection": "Alpinist"
    }
  },
  {
    "reference": "SBGA507",
    "from": {
      "brand": "Seiko",
      "collection": "U.S. Limited Edition"
    },
    "to": {
      "brand": "Grand Seiko",
      "collection": "Heritage"
    }
  }
];
function sfCanonicalWatchIdentity(watch) {
  if (!watch || typeof watch !== 'object' || Array.isArray(watch)) return watch;
  for (var i = 0; i < sfCatalogueIdentityAliases.length; i++) {
    var alias = sfCatalogueIdentityAliases[i];
    if (watch.brand === alias.from.brand && watch.collection === alias.from.collection && watch.reference === alias.reference) {
      return Object.assign({}, watch, { brand: alias.to.brand, collection: alias.to.collection });
    }
  }
  return watch;
}
function sfCanonicalSavedWatches(watches) {
  return Array.isArray(watches) ? watches.map(sfCanonicalWatchIdentity) : watches;
}
function sfLegacyQueryAlias(search) {
  try {
    var params = new URLSearchParams(search);
    if (params.getAll('brand').length !== 1 || params.getAll('collection').length !== 1 || params.getAll('reference').length !== 1) return null;
    // Existing Finder links remove whitespace; Shopify also normalizes encoded spaces to plus.
    // Accept those representations only for the six complete approved old identities.
    var brand = params.get('brand').replace(/\s+/g, '');
    var collection = params.get('collection').replace(/\s+/g, '');
    var reference = params.get('reference');
    for (var i = 0; i < sfCatalogueIdentityAliases.length; i++) {
      var alias = sfCatalogueIdentityAliases[i];
      if (brand === alias.from.brand.replace(/\s+/g, '') && collection === alias.from.collection.replace(/\s+/g, '') && reference === alias.reference) {
        return { brand: alias.to.brand, collection: alias.to.collection, reference: alias.reference };
      }
    }
    return null;
  } catch (e) { return null; }
}
function sfCanonicalFinderQueryUrl(location) {
  if (!location || location.pathname !== '/pages/strap-finder') return null;
  var alias = sfLegacyQueryAlias(location.search);
  if (!alias) return null;
  var query = location.search.slice(1).split('&').map(function(part) {
    var equalAt = part.indexOf('=');
    var rawKey = equalAt < 0 ? part : part.slice(0, equalAt);
    var key;
    try { key = decodeURIComponent(rawKey.replace(/\+/g, ' ')); } catch (e) { return part; }
    // The main Finder engine compares compact values, unlike the drawer's labels.
    if (key === 'brand') return 'brand=' + encodeURIComponent(alias.brand.replace(/\s+/g, ''));
    if (key === 'collection') return 'collection=' + encodeURIComponent(alias.collection.replace(/\s+/g, ''));
    return part;
  }).join('&');
  return location.pathname + '?' + query + (location.hash || '');
}
function sfRedirectLegacyFinderQuery() {
  try {
    var destination = sfCanonicalFinderQueryUrl(window.location);
    if (!destination) return false;
    window.location.replace(destination);
    return true;
  } catch (e) { return false; }
}
function sfRestoreCatalogueIdentity() {
  try {
    var original = { brand: localStorage.getItem('brand'), collection: localStorage.getItem('model'), reference: localStorage.getItem('reference') };
    var canonical = sfCanonicalWatchIdentity(original);
    if (canonical !== original) {
      localStorage.setItem('brand', canonical.brand);
      localStorage.setItem('model', canonical.collection);
    }
  } catch (e) {}
}
// A separate main-page engine reads the URL independently of the drawer.
// Replace legacy Finder URLs before registering drawer initialization; the compact canonical URL is not an alias, so there is no loop.
sfRedirectLegacyFinderQuery();

var jsonDataUrl = $('.jsc-watch-finder').attr('sheety-api'); 

// Delugs: fire-and-forget logging of finder selections to sf.delugs.com.
// Never blocks or breaks the finder. v2: persistent device id (localStorage,
// so anonymous history can be stitched to a customer when they log in) +
// anonymous watch selections mirrored to Klaviyo onsite (merges into the
// profile retroactively if the visitor ever identifies).
function sfLogSelection(eventType, brand, collection, reference, extra){
  try {
    if (!window.DelugsFinderAnalytics.allowed()) return;
    if (brand == null) brand = localStorage.getItem('brand') || '';
    if (collection == null) collection = localStorage.getItem('model') || '';
    if (eventType === 'reference_selected') {
      if (sfLogSelection._last === reference) return; // skip consecutive dupes
      sfLogSelection._last = reference;
    }
    var sid = '';
    try { sid = localStorage.getItem('sf_sid') || sessionStorage.getItem('sf_sid') || ''; } catch (e0) {}
    if (!sid) { sid = 's' + Math.random().toString(36).slice(2) + Date.now().toString(36); }
    try { localStorage.setItem('sf_sid', sid); } catch (e1) {}
    var cid = $('jsc-watch-finder').attr('customer-id') || '';
    var payloadObj = {
      eventType: eventType, brand: brand || '', collection: collection || '', reference: reference || '',
      sessionId: sid,
      pageType: $('jsc-watch-finder--drop-down').attr('sfPageType') || '',
      referrer: window.location.pathname
    };
    if (extra) { for (var xk in extra) { payloadObj[xk] = extra[xk]; } }
    window.DelugsFinderAnalytics.send(payloadObj);
    // Preserve the existing onsite anonymous event, now behind analytics consent.
    // Server identity comes only from the signed proxy, never this DOM hint.
    if (eventType === 'reference_selected' && !cid && window.klaviyo) {
      try { window.klaviyo.push(['track', 'Strap Finder Watch Selected', { Brand: brand || '', Collection: collection || '', Reference: reference || '', Source: 'strap-finder-anonymous' }]); } catch (e2) {}
    }
  } catch (err) {}
}

var blankLi = `<li class="custom-select--item custom-select__option js-option" id="jsc-brand-blank" role="option" data-value="blank"></li>`;
let cachedWatchDb = null;

// Helper function to safely parse JSON from HTML attribute, handling special characters
const safeParseJSON = (jsonString, defaultValue = []) => {
    if (!jsonString) {
        return defaultValue;
    }
    try {
        // Decode HTML entities (like &quot; back to ")
        let decodedData = $('<div>').html(jsonString).text();
        
        // Trim whitespace
        decodedData = decodedData.trim();
        
        // Parse the JSON
        const parsed = JSON.parse(decodedData);
        return sfCanonicalSavedWatches(Array.isArray(parsed) ? parsed : (parsed ? [parsed] : defaultValue));
    } catch (e) {
        console.error('❌ Error parsing JSON:', e.message);
        console.error('Raw data length:', jsonString ? jsonString.length : 0);
        // Return empty array on error to prevent breaking the page
        return defaultValue;
    }
};

// ── Delugs split-API data layer ─────────────────────────────────────────
// The drawer no longer downloads the full catalog. On load it fetches a tiny
// index (brands + per-brand version stamps); a brand's watches load on demand
// and merge into cachedWatchDb, so every existing filter-by-brand function
// keeps working unchanged. Brand payload URLs carry ?v= so the CDN can cache
// them hard while edits still propagate within the index's 60s window.
let sfIndex = null;
let sfBrandCache = {};
var sfApiBase = (function(){
  try { var m = String(jsonDataUrl||'').match(/^(https?:\/\/[^\/]+)/); if (m) return m[1]; } catch(e) {}
  return 'https://sf.delugs.com';
})();
function sfRebuildDb(){
  var all = [];
  for (var k in sfBrandCache) { if (sfBrandCache.hasOwnProperty(k)) all = all.concat(sfBrandCache[k]); }
  cachedWatchDb = all;
}
function sfBrandMeta(name){
  if (!sfIndex || !sfIndex.brands) return null;
  var n = String(name||'').toLowerCase();
  var ns = n.replace(/\s+/g,'');
  for (var i = 0; i < sfIndex.brands.length; i++) {
    var b = sfIndex.brands[i];
    var bn = b.name.toLowerCase();
    if (bn === n || bn.replace(/\s+/g,'') === ns) return b;
  }
  return null;
}
function sfBrandLoaded(name){
  var meta = sfBrandMeta(name);
  return !!(meta && sfBrandCache[meta.name]);
}
function sfLoadBrand(brand){
  var meta = sfBrandMeta(brand);
  var name = meta ? meta.name : String(brand||'');
  if (!name) return $.Deferred().resolve([]).promise();
  if (sfBrandCache[name]) return $.Deferred().resolve(sfBrandCache[name]).promise();
  if (sfLoadBrand._inflight && sfLoadBrand._inflight[name]) return sfLoadBrand._inflight[name];
  var v = meta ? meta.v : 'x';
  var p = $.getJSON(sfApiBase + '/api/strap-finder/brand/' + encodeURIComponent(name) + '?v=' + encodeURIComponent(v))
    .then(function(d){
      sfBrandCache[name] = (d && d.sheet1) || [];
      sfRebuildDb();
      sfRefreshPersistedDisplays();
      return sfBrandCache[name];
    });
  sfLoadBrand._inflight = sfLoadBrand._inflight || {};
  sfLoadBrand._inflight[name] = p;
  p.always(function(){ delete sfLoadBrand._inflight[name]; });
  return p;
}
const fetchWatchDb = () => {
    return $.getJSON(sfApiBase + '/api/strap-finder/index').then((idx) => {
        sfIndex = idx;
        cachedWatchDb = [];
        sfRefreshPersistedDisplays();
        return cachedWatchDb;
    });
};


// Persisted entries retain customer choices; current catalogue owns display metadata.
function sfPersistedWatchId(w) {
  var id = String((w && (w.watchId || w.id)) || '');
  return /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(id) ? id.toLowerCase() : '';
}
function sfPersistedPageKey(value) {
  try {
    var u = new URL(value || '', 'https://delugs.com');
    if (!/^(www\.)?delugs\.com$/i.test(u.hostname) || !/^\/(pages\/straps-|products\/)/.test(u.pathname)) return '';
    return u.pathname.replace(/\/$/, '');
  } catch (e) { return ''; }
}
function sfCurrentPersistedWatch(w) {
  w = sfCanonicalWatchIdentity(w);
  if (!w || !Array.isArray(cachedWatchDb)) return null;
  var id = sfPersistedWatchId(w);
  var rows = cachedWatchDb.filter(function(row) { return row.status === 1; });
  if (id) {
    var byId = rows.filter(function(row) { return sfPersistedWatchId(row) === id; });
    return byId.length === 1 ? byId[0] : null;
  }
  var page = sfPersistedPageKey(w.url);
  if (page) {
    var byPage = rows.filter(function(row) {
      return String(row.brand || '').trim() === String(w.brand || '').trim() && sfPersistedPageKey(row.modelLandingPage) === page;
    });
    if (byPage.length === 1) return byPage[0];
    if (byPage.length > 1) return null;
  }
  var exact = rows.filter(function(row) {
    return String(row.brand || '').trim() === String(w.brand || '').trim() &&
      String(row.collection || '').trim() === String(w.collection || '').trim() &&
      String(row.reference || '').replace(/\s+/g, '') === String(w.reference || '').replace(/\s+/g, '');
  });
  return exact.length === 1 ? exact[0] : null;
}
function sfPersistedWatchDisplay(w) {
  var row = sfCurrentPersistedWatch(w);
  if (!row) return sfCanonicalWatchIdentity(w);
  return Object.assign({}, w, {
    watchId: sfPersistedWatchId(row), brand: row.brand, collection: row.collection,
    model: row.model, reference: row.reference, identifier: row.identifier,
    image: row.watchImage || w.image, watchImage: row.watchImage || w.watchImage,
    url: w.url || row.modelLandingPage || ''
  });
}
function sfHydratePersistedBrands(watches) {
  if (!sfIndex) return;
  sfHydratePersistedBrands.attempted = sfHydratePersistedBrands.attempted || {};
  watches.forEach(function(w) {
    var meta = sfBrandMeta(sfCanonicalWatchIdentity(w).brand);
    if (!meta || sfBrandLoaded(meta.name) || sfHydratePersistedBrands.attempted[meta.name]) return;
    sfHydratePersistedBrands.attempted[meta.name] = true;
    // sfLoadBrand shares in-flight requests and refreshes displays only on success.
    sfLoadBrand(meta.name).then(null, function() {});
  });
}
function sfRefreshPersistedDisplays() {
  renderRecentWatches();
  if ($('jsc-watch-finder').attr('customer-id')) updateLoggedInWatchCollection();
  else updateSessionStorageWatchCollection();
}

// ====== Recently Viewed Watches ======
function saveRecentWatch(brand, collection, reference, watchImage, url) {
var canonical = sfCanonicalWatchIdentity({brand:brand, collection:collection, reference:reference});
  brand = canonical.brand; collection = canonical.collection;

  if (!reference) return;
  try {
    var recent = sfCanonicalSavedWatches(JSON.parse(localStorage.getItem('sf_recent_watches') || '[]'));
    // Remove if already exists
    recent = recent.filter(function(w) { return w.reference !== reference; });
    // Add to front
    recent.unshift({ brand: brand, collection: collection, reference: reference, image: watchImage, url: url || '', ts: Date.now() });
    // Keep max 5
    recent = recent.slice(0, 5);
    localStorage.setItem('sf_recent_watches', JSON.stringify(recent));
  } catch(e) {}
}

function renderRecentWatches() {
  try {
    var recent = sfCanonicalSavedWatches(JSON.parse(localStorage.getItem('sf_recent_watches') || '[]'));
    $('#sf-recent-watches').remove();
    if (!recent.length || !cachedWatchDb) return;
    sfHydratePersistedBrands(recent.slice(0, 3));
    var $container = $('jsc-watch-finder-content');
    var existing = $('#sf-recent-watches');
    if (existing.length) existing.remove();

    var html = '<div id="sf-recent-watches" style="padding:8px 12px 0;"><div style="display:flex;justify-content:space-between;align-items:center;margin:0 0 6px;"><p style="font-size:11px;font-weight:600;color:#999;text-transform:uppercase;letter-spacing:0.5px;margin:0;">Recently Viewed</p><button onclick="clearRecentWatches()" style="font-size:10px;color:#999;background:none;border:none;cursor:pointer;padding:0;text-decoration:underline;">Clear</button></div>';
    recent.slice(0, 3).forEach(function(w, i) {
      w = sfPersistedWatchDisplay(w);
      html += '<div onclick="quickSelectWatch(' + i + ')" style="display:flex;align-items:center;gap:8px;padding:6px 8px;border-radius:6px;cursor:pointer;margin-bottom:4px;border:1px solid #eee;" onmouseover="this.style.background=\'#f5f5f5\'" onmouseout="this.style.background=\'\'">';
      if (w.image) html += '<img src="' + w.image + (w.image.indexOf('?') === -1 ? '?' : '&') + 'width=60&height=60&crop=center" style="width:32px;height:32px;object-fit:contain;border-radius:3px;background:#f9f9f9;" />';
      html += '<div style="flex:1;min-width:0;"><div style="font-size:12px;font-weight:500;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">' + w.brand + ' ' + w.collection + '</div><div style="font-size:10px;color:#999;">' + w.reference + '</div></div></div>';
    });
    html += '</div>';
    $container.prepend(html);
  } catch(e) {}
}

function quickSelectWatch(index) {
  try {
    var recent = JSON.parse(localStorage.getItem('sf_recent_watches') || '[]');
    var original = recent[index];
    if (!original) return;
    var w = sfCanonicalWatchIdentity(original);
    setLocalStorage('brand', w.brand);
    setLocalStorage('model', w.collection);
    setLocalStorage('reference', w.reference);
    function navigate() {
      var dest = w.url || resolveRecentWatchUrl(w);
      if (dest) { window.location.href = dest; } else { location.reload(); }
    }
    // Only a corrected URL-less legacy entry needs the moved brand loaded.
    if (w !== original && !w.url && !sfBrandLoaded(w.brand)) {
      sfLoadBrand(w.brand).then(navigate, function() { location.reload(); });
    } else { navigate(); }
  } catch(e) { location.reload(); }
}

// Fallback for legacy recent-watch entries saved before the destination URL
// was stored: look up the watch's dedicated landing page from the loaded DB.
function resolveRecentWatchUrl(w) {
w = sfCanonicalWatchIdentity(w);

  try {
    if (!w || !cachedWatchDb || !Array.isArray(cachedWatchDb)) return '';
    var wref = String(w.reference || '').replace(/\s+/g, '');
    var matches = cachedWatchDb.filter(function(item) {
      return item.status === 1 &&
        String(item.brand).trim() === String(w.brand).trim() &&
        String(item.collection).trim() === String(w.collection).trim();
    });
    var chosen = matches.filter(function(item) {
      return String(item.reference || '').replace(/\s+/g, '') === wref;
    })[0] || matches[0];
    if (chosen && chosen.modelLandingPage && (chosen.modelLandingPage.indexOf('/pages') !== -1 || chosen.modelLandingPage.indexOf('/products') !== -1)) {
      return chosen.modelLandingPage;
    }
  } catch(e) {}
  return '';
}

function clearRecentWatches() {
  localStorage.removeItem('sf_recent_watches');
  $('#sf-recent-watches').remove();
}

$(function () {
    // Search has its own endpoint and must work even while index/restoration fails.
    initSmartSearch();
    fetchWatchDb().then(() => {
    onLoadFunctionInit();
    renderRecentWatches();
    }).fail(function(error) { console.warn('Watch browsing initialization failed; reference search remains available.', error); }); 
    // onLoadOpenDrawer();
    
    // Check if user just logged in and migrate session storage
    const customerId = $('jsc-watch-finder').attr('customer-id');

    if (customerId) {
        // Check if this is a fresh login (session storage exists but metafields might not be ready)
        const hasSessionWatches = sessionStorage.getItem('sf_session_watches');
        console.log('🔍 Session watches check:', hasSessionWatches);
        if (hasSessionWatches) {
            // Add a delay before migration to allow Shopify to update metafields
            console.log('🔍 Fresh login detected, delaying migration by 3 seconds...');
            setTimeout(() => {
                console.log('🔍 Starting migration after delay...');
                migrateSessionStorageToMetafields();
            }, 3000); // 3 second delay
        } else {
            console.log('🔍 No session watches, running migration immediately...');
            migrateSessionStorageToMetafields();
            
            // Also update watch collection for normal login
            updateLoggedInWatchCollection();
        }
    } else {
        console.log('🔍 No customer ID, initializing session storage display...');
        // For non-logged-in users, initialize session storage display
        updateSessionStorageWatchCollection();
        
        // Update icons in Strap Finder tab
        updateStrapFinderTabIcons();
    }
});

sfDrawerChangeTab= (type) => {
  $('#Watch-Finder--Drawer').find('.sf-drawer-tab').removeClass('active');
  $('#Watch-Finder--Drawer').find('.side-panel-content').removeClass('active');

  if (type === 'sf') {
    $('#Watch-Finder--Drawer').find('.sf-drawer-tab[data-type="' + type + '"]').addClass('active'); 
    $('#Watch-Finder--Drawer').find('.side-panel-content.sf-panel-content-strap-finder').addClass('active');
  }else{
    $('#Watch-Finder--Drawer').find('.sf-drawer-tab[data-type="' + type + '"]').addClass('active'); 
    $('#Watch-Finder--Drawer').find('.side-panel-content.sf-panel-content-saved-watch').addClass('active');
  }
}
// onLoadOpenDrawer = () => {
//   const hash = window.location.hash;
//   if (hash.startsWith('#product-card-')) {

//     // Scroll to the element with that ID after drawer opens
//     setTimeout(function () {
//         openWfDrawer();
//         const targetId = hash.substring(1); // remove '#'
//         const $targetElement = $('#' + targetId); // jQuery selector
 
//         if ($targetElement.length) {
//           // Scroll to product card
//           const drawerContent = document.querySelector('#Watch-Finder--Drawer'); // Update selector if needed
//           const targetOffsetTop = $targetElement.offset().top;
        
//           // Scroll the drawer content manually with offset (e.g., -23px)
//           $(drawerContent).animate({
//             scrollTop: targetOffsetTop - 55 // adjust for padding/header
//           }, 500); // duration in ms
//           // save watch if not already saved
//           const $saveBtn = $targetElement.find('.jsc-sf-product-card-save-watch');
//           if (!$saveBtn.hasClass('sf-filled')) {
//             $saveBtn.find('.sf-save-watch-button').click();
//           }
//         }
//       }, 1500);
      
   
//   }
// }

openWfDrawer = (sfPageType) =>{
    $('#Watch-Finder--Drawer').addClass('active');
    $('body').addClass('open-cc');

    onLoadSetLocalStorage();
    var getBrandLocalStorage = localStorage.getItem('brand'); 
    var getModelLocalStorage = localStorage.getItem('model');

    if (sfPageType == 'brand' || sfPageType == 'model'){
        $('jsc-watch-finder--drop-down').attr('sfPageType',sfPageType);
        $('#jsc-brand button input').attr('disabled',true);
        $('#jsc-brand button span').removeAttr('onclick');
        $('.jsc-watch-finder--clear').hide();
    }else{
        $('jsc-watch-finder--drop-down').attr('sfPageType',sfPageType);
        $('#jsc-brand button input').attr('disabled',false);
        $('#jsc-brand button span').attr('onclick','toggleBrandDropdown()');
        $('.jsc-watch-finder--clear').show();
    }

            setTimeout(function () {
              loadBrandOption(getBrandLocalStorage);
            }, 1000);
            var brandValue = getBrandLocalStorage ? "Brand: " + getBrandLocalStorage : "-- Select Brand --";
            $('#jsc-brand .custom-select--button .jsc-brand-search').attr('placeholder',brandValue);
            $('#jsc-brand .custom-select--button .jsc-brand-search').val(brandValue);
            $('#jsc-brand .custom-select--button .jsc-brand-search').addClass('jsc-placeholder-black-color');
   
            loadModelOption (getBrandLocalStorage, sfPageType) ;
            var modelValue = getModelLocalStorage ? "Collection: " + getModelLocalStorage : "-- Select Collection --";
            $('#jsc-model .custom-select--button .jsc-model-search').attr('placeholder',modelValue);
            $('#jsc-model .custom-select--button .jsc-model-search').val(modelValue);
            $('#jsc-model .custom-select--button .jsc-model-search').addClass('jsc-placeholder-black-color');
            loadEngineOption(getModelLocalStorage,sfPageType,getBrandLocalStorage);

             // pre open model dropdown for brand and model page  
            if (sfPageType === 'brand' || sfPageType === 'model') {
                setTimeout(function () {
                  const modelContainer = $('#jsc-model');
                  const modelItems = modelContainer.find('ul li');
              
                  if (modelItems.length > 1) {
                    modelContainer.addClass('custom-select--active');
                  } else {
                    // Disable the input inside #jsc-model
                    modelContainer.find('input').prop('disabled', true);
                    modelContainer.find('button span').removeAttr('onclick');

                  }
                }, 100);
              }
}

if ($('jsc-watch-finder--drop-down').length > 0) { // only for watch finder template
    $(document).on('click', function(event) {
        var $dropdown = $('jsc-custom-select button');
        var getBrandLocalStorage = localStorage.getItem('brand');
        var getModelLocalStorage = localStorage.getItem('model');
    
        if (!$dropdown.is(event.target) && $('.jsc-custom-select').has(event.target).length === 0) {
            // Close the dropdown if it is open
            if ($('.jsc-custom-select').hasClass('custom-select--active')) {
                $('.jsc-custom-select').removeClass('custom-select--active');
                if (getBrandLocalStorage) {
                    $('#jsc-brand .custom-select--button .jsc-brand-search').addClass('jsc-placeholder-black-color');
                }else{
                    $('#jsc-brand .custom-select--button .jsc-brand-search').removeClass('jsc-placeholder-black-color');
                }
                if (getModelLocalStorage) {
                    $('#jsc-model .custom-select--button .jsc-model-search').addClass('jsc-placeholder-black-color');
                }else{
                    $('#jsc-model .custom-select--button .jsc-model-search').removeClass('jsc-placeholder-black-color');
                }
            }
        }
    });
}

onLoadSetLocalStorage = () => {
sfRestoreCatalogueIdentity();

  // Check if the URL has brand in query string (both standalone and collection URLs)
  const hasBrandParam = window.location.search.includes('?brand=') || window.location.search.includes('&brand=');
  
  if (hasBrandParam) {
        // Parse and clean URL parameters
        const queryString = window.location.search.substring(1);
        // console.log('🔍 Original Query String:', queryString);
        
        // Handle malformed URLs by fixing common issues
        let fixedQueryString = queryString;
        
        // Fix the specific case where brand value is concatenated with collection
        // brand=Cartiercollection=Tortue -> brand=Cartier&collection=Tortue
        if (fixedQueryString.includes('brand=') && fixedQueryString.includes('collection=') && !fixedQueryString.includes('&collection=')) {
            fixedQueryString = fixedQueryString.replace(/brand=([^&]+)collection=/, 'brand=$1&collection=');
            // console.log('🔧 Fixed brand-collection separator');
        }
        
        // Fix the specific case where collection value is concatenated with reference
        // collection=Tortuereference=2396B -> collection=Tortue&reference=2396B
        if (fixedQueryString.includes('collection=') && fixedQueryString.includes('reference=') && !fixedQueryString.includes('&reference=')) {
            fixedQueryString = fixedQueryString.replace(/collection=([^&]+)reference=/, 'collection=$1&reference=');
            // console.log('🔧 Fixed collection-reference separator');
        }
        
        // Remove extra ? characters that might appear before filters
        fixedQueryString = fixedQueryString.replace(/\?filter\./g, '&filter.');
        
        // Fix the case where there's a ? in the middle of the URL (like filter.v.availability=1?brand)
        fixedQueryString = fixedQueryString.replace(/=([^&]+)\?([^=]+)=/g, '=$1&$2=');
        
        // console.log('🔧 Fixed Query String:', fixedQueryString);
        
        // Split by & to handle parameters properly
        const params = fixedQueryString.split('&');
        let rawBrand = '';
        let rawModel = '';
        let rawYear = '';
        
        // Parse each parameter manually to avoid issues with filter parameters
        params.forEach(param => {
            if (param && param.includes('=')) {
                const [key, value] = param.split('=');
                // console.log('🔍 Parsing param:', key, '=', value);
                if (key === 'brand') {
                    rawBrand = decodeURIComponent(value || '');
                } else if (key === 'collection') {
                    rawModel = decodeURIComponent(value || '');
                } else if (key === 'reference') {
                    rawYear = decodeURIComponent(value || '');
                }
            }
        });
        
        // Fallback: If we still don't have proper values, try a more aggressive approach
        if (!rawBrand || !rawModel || !rawYear) {
            // console.log('⚠️ Fallback parsing needed');
            
            // Try to extract from the original query string using regex
            const brandMatch = queryString.match(/brand=([^&?]+)/);
            const collectionMatch = queryString.match(/collection=([^&?]+)/);
            const referenceMatch = queryString.match(/reference=([^&?]+)/);
            
            if (brandMatch) rawBrand = decodeURIComponent(brandMatch[1]);
            if (collectionMatch) rawModel = decodeURIComponent(collectionMatch[1]);
            if (referenceMatch) rawYear = decodeURIComponent(referenceMatch[1]);
            
            // console.log('🔍 Fallback extracted:', rawBrand, rawModel, rawYear);
        }

        var sfAlias = sfLegacyQueryAlias(window.location.search);
        if (sfAlias) { rawBrand = sfAlias.brand; rawModel = sfAlias.collection; rawYear = sfAlias.reference; }
        const cleanBrand = encodeURIComponent(rawBrand.replace(/\s+/g, ''));
        const cleanModel = encodeURIComponent(rawModel.replace(/\s+/g, ''));
        const cleanYear = encodeURIComponent(rawYear.replace(/\s+/g, ''));

        // console.log('🔍 Raw URL Parameters:', rawBrand, rawModel, rawYear);
        // console.log('🔍 Encoded URL Parameters:', cleanBrand, cleanModel, cleanYear);

        // Search in cached DB
        var watchDb = cachedWatchDb;

        var match = watchDb.find(item => {
         
            const encodedBrand = encodeURIComponent(String(item.brand || '').replace(/\s+/g, ''));
            const encodedModel = encodeURIComponent(String(item.collection || '').replace(/\s+/g, ''));
           const encodedReference = encodeURIComponent(String(item.reference || '').replace(/\s+/g, ''));

            // Log comparison for debugging
            // console.log(`🧪 Checking: ${encodedBrand}, ${encodedModel}, ${encodedReference}`);

            return (
                encodedBrand === cleanBrand &&
                encodedModel === cleanModel  &&
                encodedReference === cleanYear
            );
        });

        if (match) {
            localStorage.setItem('brand', match.brand);
            localStorage.setItem('model', match.collection);
            localStorage.setItem('reference', match.reference);
            // console.log('✅ Match found & saved to localStorage:', match);
        } else {
            // console.log('❌ No match found for brand/collection/year in watchDb.');
        }
    }
}

onLoadFunctionInit = () =>{
sfRestoreCatalogueIdentity();

    // Preload whichever brand this page needs (URL param or saved selection)
    // BEFORE the restore logic runs — the URL matcher and the populate
    // functions read that brand's rows from cachedWatchDb.
    var sfRun = function(){
        onLoadSetLocalStorage();
        var getBrandLocalStorage = localStorage.getItem('brand');
        var getModelLocalStorage = localStorage.getItem('model');
        var getReferenceLocalStorage = localStorage.getItem('reference');
        loadBrandOption(getBrandLocalStorage);
        onloadPopulateWatchFilterFromLocalStorage(getBrandLocalStorage,getModelLocalStorage);
        if ($('jsc-watch-finder--drop-down').length > 0) { // only for watch finder template
            onloadWatchButton(getBrandLocalStorage,getModelLocalStorage);
        }else{
            onloadPopulateReferenceFilterFromLocalStorage(getBrandLocalStorage,getModelLocalStorage,getReferenceLocalStorage);
        }
    };
    var sfUrlBrand = '';
    try {
        var m = window.location.search.match(/brand=([^&?]+)/);
        if (m) sfUrlBrand = decodeURIComponent(m[1]);
    } catch (e) {}
    var sfAlias = sfLegacyQueryAlias(window.location.search);
    if (sfAlias) sfUrlBrand = sfAlias.brand;
    var sfNeed = sfUrlBrand || localStorage.getItem('brand');
    if (sfNeed) { sfLoadBrand(sfNeed).always(sfRun); } else { sfRun(); }
}

handleizedString = (input) => {
    let string = String(input);
    return string.replace(/\s+/g, '-').replace(/\//g, '-').trim().toLowerCase().replace('(', '-').replace(')', '-').replace(/--/g, '-').replace('.', '-').replace(/√∂/g, '-');
}

populateModelHtml = (brand, localStorageModel, sfPageType) => {

    // Check if cachedWatchDb is available
    if (!cachedWatchDb || !Array.isArray(cachedWatchDb)) {
        console.warn('⚠️ cachedWatchDb is not available yet, skipping populateModelHtml');
        return;
    }
    if (brand && !sfBrandLoaded(brand)) { sfLoadBrand(brand).then(function(){ populateModelHtml(brand, localStorageModel, sfPageType); }); return; }

    // Filter the JSON data for the selected "Brand"
    var filteredData = cachedWatchDb.filter(function(item) {
        if (sfPageType === 'brand') {
            // For brand-specific pages, only show models that match the brand
            // and have a brand-specific collection
            return item.status === 1 &&
                   item.brand === brand && 
                   item.brandSpecificCollection && 
                   item.brandSpecificCollection.includes('/collections');
        } 
        else if  (sfPageType === 'model'){
             // For model landing pages, only show models that match the brand
            // and have a model-landing page
            return item.status === 1 &&
                   item.brand === brand && 
                   item.modelLandingPage && 
                   item.modelLandingPage.includes('/pages');
        }else {
            // For non-brand-specific pages, show all models for the brand
            return item.status === 1 && item.brand === brand;
        }
    });

    var modelUlElement = $('#jsc-model .custom-select__listbox');
    // Count watches per collection for popularity sort
    var collectionCounts = {};
    filteredData.forEach(function(item) {
      if (item.collection) collectionCounts[item.collection] = (collectionCounts[item.collection] || 0) + 1;
    });
    var modelOptions = [...new Set(filteredData.map(item => item.collection))].map(model => { // Delugs: Set preserves first-seen order = API demand order
        var handleizedModel = handleizedString(model);
        return `<li class="custom-select--item custom-select__option js-option" id="jsc-model-${handleizedModel}" role="option" data-value="${model}" onclick="selectOption(this,'model')" ${model == localStorageModel ? 'aria-selected="true"': 'aria-selected="false"' }>
                <span class="${model == localStorageModel ? 'custom-select--active' : ''}">${model} <span style="color:#999;font-weight:400;">(${collectionCounts[model] || 0})</span></span>
                </li>`;
    });

    modelUlElement.html(modelOptions.join(''));
}

populateReferenceHtml = (brand, model, localStorageReference) => {
    // Check if cachedWatchDb is available
    if (!cachedWatchDb || !Array.isArray(cachedWatchDb)) {
        console.warn('⚠️ cachedWatchDb is not available yet, skipping populateReferenceHtml');
        return;
    }
    if (brand && !sfBrandLoaded(brand)) { sfLoadBrand(brand).then(function(){ populateReferenceHtml(brand, model, localStorageReference); }); return; }

    // Filter the JSON data for the selected "Brand" and "Model"
    var filteredData = cachedWatchDb.filter(function(item) {
        return item.status === 1 && item.brand === brand && item.collection === model;
    });

    var modelUlElement = $('#jsc-reference .custom-select__listbox');
    // Build reference → image map for thumbnails
    var refImageMap = {};
    filteredData.forEach(function(item) {
      if (item.reference && item.watchImage && !refImageMap[item.reference]) {
        refImageMap[item.reference] = item.watchImage;
      }
    });
    var modelOptions = [...new Set(filteredData.map(item => item.reference))].sort().map(reference => {
        var handleizedReference = handleizedString(reference);
        var refThumb = refImageMap[reference] || ''; 
        return `<li class="custom-select--item custom-select__option js-option" id="jsc-reference-${handleizedReference}" role="option" data-value="${reference}" onclick="selectOption(this,'reference')" ${reference == localStorageReference ? 'aria-selected="true"': 'aria-selected="false"' }>
                <span class="${reference == localStorageReference ? 'custom-select--active' : ''}" style="display:flex;align-items:center;gap:8px;">${refThumb ? '<img src="' + refThumb + '?width=40&height=40&crop=center" style="width:28px;height:28px;object-fit:contain;border-radius:3px;background:#f5f5f5;" loading="lazy" />' : ''}${reference}</span>
                </li>`;
    });

    modelUlElement.html(modelOptions.join(''));
};

populateReferenceImageHtmlByBrand = (brand,isPageType) => {
    // Check if cachedWatchDb is available
    if (!cachedWatchDb || !Array.isArray(cachedWatchDb)) {
        console.warn('⚠️ cachedWatchDb is not available yet, skipping populateReferenceImageHtmlByBrand');
        return;
    }
    if (brand && !sfBrandLoaded(brand)) { sfLoadBrand(brand).then(function(){ populateReferenceImageHtmlByBrand(brand, isPageType); }); return; }

    let brandString = String(brand);
      // Filter the JSON data for the selected "Brand"
      var filteredData = cachedWatchDb.filter(function(item) {
        return item.status === 1 &&  
               String(item.brand).trim() === brandString;
    });
    
    var engineUlElement = $('jsc-year-reference-img');
    engineUlElement.empty();
            
    var tableHTMLArray = filteredData.map(item => {
    // Get unique yearnum values for the current engineImg
    var uniqueYearNums = [...new Set(filteredData.filter(data => data.watchImage === item.watchImage).map(data => data.reference))];
    // Join unique yearnum values into a comma-separated string
    var yearNumString = uniqueYearNums.join(', ');
    // Collect article handles (only if they exist)
    var articleHandles = [item.article1, item.article2, item.article3].filter(Boolean).join('>');
    // console.log(articleHandles, 'articleHandles'); 
    // Store the data in the array
    return `${yearNumString}|~|${item.watchImage}|~|${item.caseDiameter}|~|${item.lugToLugDistance}|~|${item.lugWidth}|~|${item.watchHeadImage}|~|${articleHandles}|~|${item.recommendedCollection}|~|${item.brand}|~|${item.collection}|~|${item.brandSpecificPage}|~|${item.model}|~|${item.modelLandingPage}|~|${item.identifier}`;
     });
//   console.log('tableHTMLArray', tableHTMLArray, 'isPageType', isPageType);
    loadTableRow(tableHTMLArray,isPageType);
}

populateReferenceImageHtml = (model,isPageType,brand) => {
    // Check if cachedWatchDb is available
    if (!cachedWatchDb || !Array.isArray(cachedWatchDb)) {
        console.warn('⚠️ cachedWatchDb is not available yet, skipping populateReferenceImageHtml');
        return;
    }
    if (brand && !sfBrandLoaded(brand)) { sfLoadBrand(brand).then(function(){ populateReferenceImageHtml(model, isPageType, brand); }); return; }

    let modelString = String(model); 
    let brandString = String(brand);
      // Filter the JSON data for the selected "Model" and "Brand"
      var filteredData = cachedWatchDb.filter(function(item) {
        return item.status === 1 && 
                String(item.collection).trim() === modelString &&
               String(item.brand).trim() === brandString;
    });

    
    var engineUlElement = $('jsc-year-reference-img');
    engineUlElement.empty(); // Remove existing children
            
    var tableHTMLArray = filteredData.map(item => {
    // Get unique yearnum values for the current engineImg
    var uniqueYearNums = [...new Set(filteredData.filter(data => data.watchImage === item.watchImage).map(data => data.reference))];
    // Join unique yearnum values into a comma-separated string
    var yearNumString = uniqueYearNums.join(', ');
    // Collect article handles (only if they exist)
    var articleHandles = [item.article1, item.article2, item.article3].filter(Boolean).join('>');
    // console.log(articleHandles, 'articleHandles'); 
    // Store the data in the array
    return `${yearNumString}|~|${item.watchImage}|~|${item.caseDiameter}|~|${item.lugToLugDistance}|~|${item.lugWidth}|~|${item.watchHeadImage}|~|${articleHandles}|~|${item.recommendedCollection}|~|${item.brand}|~|${item.collection}|~|${item.brandSpecificPage}|~|${item.model}|~|${item.modelLandingPage}|~|${item.identifier}`;
     });

    loadTableRow(tableHTMLArray,isPageType);
}

loadTableRow = (htmlArray, isPageType) => {
    var engineUlElement = $('jsc-year-reference-img');
    engineUlElement.children().remove();
    const row = $('<div>').addClass('jsc-year-img-items-wrapper');
    var getReferenceLocalStorage = localStorage.getItem('reference');
  
    let appendedCount = 0; // Track how many items get appended
    const cardList = [];   // Store product cards temporarily

    let customerId = $('jsc-watch-finder').attr('customer-id');
    let customerMetafieldData = $('jsc-watch-finder').attr('customer-save-watch-list');
    let watchList = safeParseJSON(customerMetafieldData, []);

    // Update counters based on user login status
    if (customerId) {
        // Logged-in user - use metafield data
        if (watchList && watchList.length >= 50) {
            $('.sf-saved-watch-error-limit-message').show();
            $('.sf-saved-watch-count-message').hide();
        } else if (watchList && watchList.length > 0) {
            $('.sf-saved-watch-error-limit-message').hide();
            $('.sf-saved-watch-count-message').show();
            $('.sf-saved-watch-count-message .sf-saved-watch-count').text(watchList.length);
        } else {
            $('.sf-saved-watch-error-limit-message').hide();
            $('.sf-saved-watch-count-message').hide();
        }
    } else {
        // Non-logged-in user - use session storage
        updateSessionStorageCounters();
    }
    for (let index = 0; index < htmlArray.length; index++) {
      const parts = htmlArray[index].split('|~|');

      let heartFill = 'none'; // default

      if (customerId && Array.isArray(watchList)) {
        // Logged-in user - check metafield data
        const isWatchListed = watchList.some(item => {
            return item.brand === parts[8] && item.collection === parts[9] && item.reference === parts[0];
        });
        heartFill = isWatchListed ? '#000000' : 'none';
      } else {
        // Non-logged-in user - check session storage
        let sessionWatches = [];
        try {
          const stored = sessionStorage.getItem('sf_session_watches');
          if (stored) {
            sessionWatches = sfCanonicalSavedWatches(JSON.parse(stored));
          }
        } catch (e) {
          sessionWatches = [];
        }
        
        const isWatchListed = sessionWatches.some(item => {
          return item.brand === parts[8] && item.collection === parts[9] && item.reference === parts[0];
        });
        heartFill = isWatchListed ? '#000000' : 'none';
      }
     
      let isLimitReached = Array.isArray(watchList) && watchList.length >= 50;
 
      // Check if the current card should be shown
      const passesFilter = (() => {
        if (isPageType === 'brand') {
          return parts[10];
        } else if (isPageType === 'model') {
          return parts[12];
        } else {
          return true;
        } 
      })();
  
      if (!passesFilter) continue;
  
      // Build product card
      const productInput = $('<input>')
        .addClass('jsc-year-img-data')
        .addClass(isLimitReached === true ? 'sf-save-watch-reached' : '')
        .attr('type', 'hidden')
        .attr('year-ref', parts[0])
        .attr('year-src', parts[1])
        .attr('case-diameter', parts[2])
        .attr('lug-to-lug-distance', parts[3])
        .attr('lug-width', parts[4])
        .attr('watch-face', parts[5])
        .attr('article-urls', parts[6])
        .attr('recommend-collection', parts[7])
        .attr('brand', parts[8])
        .attr('watch', parts[9])
        .attr('brand-specific-page', parts[10])
        .attr('model', parts[11])
        .attr('model-landing-page', parts[12])
        .attr('identifier', parts[13]);
  
      const productCard = $('<div>')
        .addClass(`jsc-year-img-item cursor columns carousel__slide`) // size class added later
        .attr('data-identifier',`${parts[13]}`)
        .attr(
          'onclick',
          `setLocalStorage('reference','${parts[0].trim()}');sfLogSelection('reference_selected',null,null,'${parts[0].trim()}');constructParamUrl('${index}',this,'${isPageType}');showWatchInfo();`
        );
  
      const productCardContent = $('<div>')
      .attr('id', `product-card-${index}`)  
        .addClass(`product-card-${index} product-card text-left product-card--content-spacing-true product-card--border-false`);

        const saveWatch = $('<div>')
            .addClass('jsc-sf-product-card-save-watch') 
            .addClass(heartFill === '#000000' ? 'sf-filled' : '')
            .addClass(isLimitReached && heartFill === 'none' ? 'sf-disabled' : '')
            .append(
                $('<div>')
                .addClass('sf-save-watch-button')
                .append(
                    $('<span>')
                    .addClass('sf-save-watch-icon')
                    .html(heartFill === '#000000' ? 
                        '<img src="https://cdn.shopify.com/s/files/1/0054/9040/9585/files/tick-circle.svg?v=1760404794" width="40" height="40" alt="Saved">' :
                        '<img src="https://cdn.shopify.com/s/files/1/0054/9040/9585/files/add-circle.svg?v=1760405891" width="40" height="40" alt="Add">'
                    )
                )
                .on('click', function (e) {
                    e.stopPropagation(); // Prevent card click
                    e.preventDefault(); // ��� Prevent anchor href navigation if inside <a>

                    // if ($(this).hasClass('disabled')) return; // ⛔ Block if disabled

                    const currentImgSrc = $(this).find('img').attr('src');
                    const isTickIcon = currentImgSrc && currentImgSrc.includes('tick-circle.svg');
                    const saveWatchParent = $(this).closest('.jsc-sf-product-card-save-watch');

                    // ⛔ If limit reached and not already saved, don't allow adding
                    customerMetafieldData = $('jsc-watch-finder').attr('customer-save-watch-list');
                    watchList = safeParseJSON(customerMetafieldData, []);
                    isLimitReached = Array.isArray(watchList) && watchList.length >= 50;
                    if (isLimitReached && !isTickIcon) {
                      
                        return;
                    }
                    
                     // construct url params
                    var $cu_brand =  parts[8].replace(/\s+/g, '');
                    var $cu_collection = parts[9].replace(/\s+/g, '');
                    var $cu_reference = parts[0].replace(/\s+/g, '');
                    // Construct URL properly
                    var sf_page_handle = $('.jsc-watch-finder').attr('sf-page');
                    var $cu_modelLandingPage = parts[12] ? parts[12].trim() : '';
                    var $cu_urlWithParams = $cu_modelLandingPage ? $cu_modelLandingPage : `/pages/${sf_page_handle}?brand=${$cu_brand}&collection=${$cu_collection}&reference=${$cu_reference}`;

                    const watchData = {
                      brand: parts[8],
                      collection: parts[9],
                      model: parts[11],
                      reference: parts[0],
                      watchImage: parts[1],
                      identifier: parts[13],
                      url: $cu_urlWithParams 

                    };
                    

                    if (customerId){
                        if (isTickIcon) {
                            // If tick icon clicked, remove from list
                            removeFromWatchList(watchData);
                            saveWatchParent.find('.sf-save-watch-icon').html('<img src="https://cdn.shopify.com/s/files/1/0054/9040/9585/files/add-circle.svg?v=1760405891" width="40" height="40" alt="Add">');
                            saveWatchParent.removeClass('sf-filled');
                        } else {
                            // If plus icon clicked, add to list
                            addToWatchList(watchData);
                            saveWatchParent.find('.sf-save-watch-icon').html('<img src="https://cdn.shopify.com/s/files/1/0054/9040/9585/files/tick-circle.svg?v=1760404794" width="40" height="40" alt="Saved">');
                            saveWatchParent.addClass('sf-filled');
                        }
                            customerMetafieldData = $('jsc-watch-finder').attr('customer-save-watch-list');
                            watchList = safeParseJSON(customerMetafieldData, []);
                            isLimitReached = Array.isArray(watchList) && watchList.length >= 50;
                   
                            if (watchList && watchList.length >= 50) {
                                $('.jsc-sf-product-card-save-watch:not(.sf-filled)').addClass('sf-disabled');
                                $('.sf-saved-watch-error-limit-message').show();
                                $('.sf-saved-watch-count-message').hide();
                            } else if (watchList && watchList.length > 0) {
                                $('.sf-saved-watch-error-limit-message').hide();
                                $('.sf-saved-watch-count-message').show();
                                $('.sf-saved-watch-count-message .sf-saved-watch-count').text(watchList.length);
                            } else {
                                $('.sf-saved-watch-error-limit-message').hide();
                                $('.sf-saved-watch-count-message').hide();
                            }
                    } else {
                        // For non-logged-in users, use session storage
                        if (isTickIcon) {
                            // If tick icon clicked, remove from session storage
                            removeFromSessionStorage(watchData);
                            saveWatchParent.find('.sf-save-watch-icon').html('<img src="https://cdn.shopify.com/s/files/1/0054/9040/9585/files/add-circle.svg?v=1760405891" width="40" height="40" alt="Add">');
                            saveWatchParent.removeClass('sf-filled');
                            updateSessionStorageCounters();
                        } else {
                            // If plus icon clicked, add to session storage
                            addToSessionStorage(watchData);
                            saveWatchParent.find('.sf-save-watch-icon').html('<img src="https://cdn.shopify.com/s/files/1/0054/9040/9585/files/tick-circle.svg?v=1760404794" width="40" height="40" alt="Saved">');
                            saveWatchParent.addClass('sf-filled');
                            updateSessionStorageCounters();
                        }
                    }


                  })
        );

        
      const productImage = $('<div>')
        .addClass('jsc-year-img')
        .append(
          $('<img>')
            .addClass('no-blur product-secondary-image lazyautosizes ls-is-cached lazyloaded')
            .attr('src', parts[1])
        );
  
      const productInfo = $('<div>').addClass('product-card-info');
      const productReferenceLabel = $('<div>')
        .addClass('jsc-year-reference-label')
        .text('Reference ')
        .append($('<span>').addClass('jsc-year-reference').text(parts[0]));
      const productModelLabel = $('<div>').addClass('jsc-model-label').append($('<span>').text(parts[11]));
  
      if (parts[0] == getReferenceLocalStorage) {
        productCardContent.addClass('border-active');
      }
  
      productCard.prepend(productInput);
      productCardContent.append(productImage);
      if (isPageType !== 'brand' && isPageType !== 'model') {
        productCardContent.append(saveWatch);
      }
      productCardContent.append(productInfo);
      productInfo.append(productModelLabel);
      productInfo.append(productReferenceLabel);
      productCard.append(productCardContent);
  
      cardList.push(productCard);
      appendedCount++;
    }
  
    
    // After loop: determine size class
    const sizeClass = appendedCount === 1 ? 'small-6 medium-12 large-12' : 'small-6 medium-6 large-6';
  
    cardList.forEach(card => {
      card.addClass(sizeClass);
      row.append(card);
    });
  
    engineUlElement.append(row);
    removeLoader();
}
  

sfPopupClose = () =>{

    // Check if current URL has #recover
    if (window.location.hash === '#recover') {
    var returnUrl = window.location.pathname + window.location.search;
    window.location.href = returnUrl; 
    }else{
    $('#sf_download_login_modal').hide();
    $('body').removeClass('open-cc');
    }
}

sfPopupRecoverPassword  = () =>{
    var returnUrl = window.location.pathname + window.location.search + '#recover';
    window.location.href = returnUrl;
}

openSfLoginPopup= (evt) =>{
  $('#Watch-Finder--Drawer').removeClass('active');
  $('#sf_download_login_modal').css('display','flex');
  $('body').addClass('open-cc');

  var $productCard = $(evt).closest('.product-card');

  if (window.location.pathname.includes('/account')) {
    $('body').removeClass('open-cc');
  }else{
    var returnUrl = window.location.href;
    if ($productCard.length) {
      var productCardId = $productCard.attr('id');
      // append return URL to login form
      returnUrl = returnUrl + '#' + productCardId;
    }else{
      returnUrl = returnUrl;
    }
     // Find all forms inside the modal container
     $('#sf_download_login_modal #customer_login').append(
      '<input type="hidden" name="return_to" value="' + returnUrl + '">'
      );
      $('#sf_download_login_modal #create_customer').append(
          '<input type="hidden" name="return_to" value="' + returnUrl + '">'
      );

      $('#sf_download_login_modal #recover').append(
          '<input type="hidden" name="return_to" value="' + returnUrl + '">'
      );
  }
}

showPopupRegisterForm = () =>{
    $('#sf_download_login_modal .jsc-modal-content .shopify-section:first').show();
    $('#sf_download_login_modal .jsc-modal-content .shopify-section:first .row').show();
    $('#sf_download_login_modal .jsc-modal-content .shopify-section:last').hide();

}

showPopupLoginForm = () =>{
    $('#sf_download_login_modal .jsc-modal-content .shopify-section:first').hide();
    $('#sf_download_login_modal .jsc-modal-content .shopify-section:last').show();
    // Check if current URL has #recover
  if (window.location.hash === '#recover') {
    var returnUrl = window.location.pathname + window.location.search;
    window.location.href = returnUrl; 
  }
}

getSingaporeTimestamp = () => {
  try {
    const timestamp = new Date().toLocaleString('sv-SE', {
      timeZone: 'Asia/Singapore',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    });
    if (!timestamp || timestamp === 'Invalid Date') {
      return new Date().toISOString();
    }
    return `${timestamp.replace(' ', 'T')}+08:00`;
  } catch (error) {
    return new Date().toISOString();
  }
};

removeFromWatchList = (watchData, e) => {
watchData = sfCanonicalWatchIdentity(watchData);

    const $watchFinder = $('jsc-watch-finder');
    const customerID = $watchFinder.attr('customer-id');
    const rawWatchList = $watchFinder.attr('customer-save-watch-list');
    const rawTags = $watchFinder.attr('customer-current-tags') || '';
    let existingTags = rawTags.split(',').map(tag => tag.trim()).filter(Boolean);
  
    let current = safeParseJSON(rawWatchList, []);
  
    // Remove matching watch
    const updated = current.filter(item =>
      !(item.brand === watchData.brand &&
        item.model === watchData.model &&
        item.collection === watchData.collection &&
        item.identifier === watchData.identifier &&
        item.reference === watchData.reference)
    );
  
    // Update saved watch list attribute
    $watchFinder.attr('customer-save-watch-list', JSON.stringify(updated));
  
    // Build a tag set from updated list
    const currentTagSet = new Set();
    const activeBrands = new Set();
    const activeModels = new Set();
    const activeCollections = new Set();
    const activeIdentifiers = new Set();
    const activeRefs = new Set();
  
    updated.forEach(watch => {
      if (watch.brand) {
        const brandTag = `sf_brand_${watch.brand.toLowerCase()}`;
        currentTagSet.add(brandTag);
        activeBrands.add(brandTag);
      }
      if (watch.model) {
        const modelTag = `sf_model_${watch.model.toLowerCase()}`;
        currentTagSet.add(modelTag);
        activeModels.add(modelTag);
      }
      if (watch.collection) {
        const collectionTag = `sf_collection_${watch.collection.toLowerCase()}`;
        currentTagSet.add(collectionTag);
        activeCollections.add(collectionTag);
      }
      if (watch.identifier) {
        const identifierTag = `sf_id_${watch.identifier.toLowerCase()}`;
        currentTagSet.add(identifierTag);
        activeIdentifiers.add(identifierTag);
      }
      if (watch.reference) {
        const refTag = `sf_ref_${watch.reference.toLowerCase()}`;
        currentTagSet.add(refTag);
        activeRefs.add(refTag);
      }
    });
  
    // Calculate number of ref tags
    const refCount = updated.length;
  
    // Clean up old _watches tags
    for (let i = 1; i <= 50; i += 5) {
      const upper = Math.min(i + 4, 50);
      currentTagSet.delete(`sf_${i}-${upper}_watches`);
    }
  
    // Add correct _watches tag
    if (refCount > 0) {
      const lowerBound = Math.floor((refCount - 1) / 5) * 5 + 1;
      const upperBound = Math.min(lowerBound + 4, 50);
      currentTagSet.add(`sf_${lowerBound}-${upperBound}_watches`);
    }
  
    // Determine new and removable tags
    const newTags = Array.from(currentTagSet).filter(tag => !existingTags.includes(tag));
    const isRemovableTag = tag =>
        tag !== 'sf_saved_watch_strap_pairing' && // Protect this tag from removal
        (tag.startsWith('sf_brand_') ||
        tag.startsWith('sf_model_') ||
        tag.startsWith('sf_collection_') ||
        tag.startsWith('sf_id_') ||
        tag.startsWith('sf_ref_') ||
        (tag.startsWith('sf_') && tag.endsWith('_watches')));
  
    const removeTags = existingTags.filter(tag => {
      if (!isRemovableTag(tag)) return false;
      if (tag.startsWith('sf_brand_')) return !activeBrands.has(tag);
      if (tag.startsWith('sf_model_')) return !activeModels.has(tag);
      if (tag.startsWith('sf_collection_')) return !activeCollections.has(tag);
      if (tag.startsWith('sf_id_')) return !activeIdentifiers.has(tag);
      if (tag.startsWith('sf_ref_')) return !activeRefs.has(tag);
      return !currentTagSet.has(tag); // e.g., _watches tags
    });
  
    // Final updated tag set
    const updatedTagSet = new Set([...existingTags, ...newTags]);
    removeTags.forEach(tag => updatedTagSet.delete(tag));
  
    // Update DOM attribute
    $watchFinder.attr('customer-current-tags', Array.from(updatedTagSet).join(','));
  
    // Debug logs
    // console.log("🧹 Removed Watch:", watchData);
    // console.log("🧩 New Tags to Add:", newTags);
    // console.log("❌ Tags to Remove:", removeTags);
    // console.log("🧩 Final Tags:", Array.from(updatedTagSet));
  
    const triggeredAt = getSingaporeTimestamp();
    // POST updated info
    $.ajax({
      url: "https://webhooks.mechanic.dev/411d70c6-afc5-463b-9db8-583a633f213a",
      method: "POST",
      contentType: "application/json",
      data: JSON.stringify({
        customer_id: customerID,
        triggered_at: triggeredAt,
        watches: updated,
        tags: Array.from(updatedTagSet)
      }),
    }).fail(error => {
      // console.error("❌ Error updating Mechanic:", error);
    });
  
    // UI cleanup on account page
    if ($('#_jscSavedWatchesList_display').length > 0) {
      $(e).closest('.columns').remove();
  
      let columns = $('#_jscSavedWatchesList_display').find('.columns');
      columns.each(function () {
        const $col = $(this);
        const brand = $col.attr('data-brand') || '';
        const model = $col.attr('data-model') || '';
        const collection = $col.attr('data-collection') || '';
        const ref = $col.attr('data-reference') || '';
  
        const isMatch = (
          brand.toLowerCase().includes(watchData.brand?.toLowerCase() || '') ||
          model.toLowerCase().includes(watchData.model?.toLowerCase() || '') ||
          collection.toLowerCase().includes(watchData.collection?.toLowerCase() || '')
        ) && ref === watchData.reference;
  
        if (isMatch) {
          $col.remove();
        }
      });
  
      columns = $('#_jscSavedWatchesList_display').find('.columns');
      if (columns.length === 0) {
        $('#_jscSavedWatchesList_display').hide();
        $('#_jscSavedWatchesList_na').show();
      }
    }

    const customerMetafieldData = $('jsc-watch-finder').attr('customer-save-watch-list');
    const watchList = safeParseJSON(customerMetafieldData, []);

    if (watchList && watchList.length >= 50) {
        $('.sf-saved-watch-error-limit-message').show();
        $('.sf-saved-watch-count-message').hide();
    } else if (watchList && watchList.length > 0) {
        $('.sf-saved-watch-error-limit-message').hide();
        $('.sf-saved-watch-count-message').show();
        $('.sf-saved-watch-count-message .sf-saved-watch-count').text(watchList.length);
    } else {
        $('.sf-saved-watch-error-limit-message').hide();
        $('.sf-saved-watch-count-message').hide();
    }
    // Update icons in Strap Finder tab for logged-in users
    updateStrapFinderTabIcons();
  };
  
  
  addToWatchList = (watchData) => {
watchData = sfCanonicalWatchIdentity(watchData);

    const $watchFinder = $('jsc-watch-finder');
    const customerID = $watchFinder.attr('customer-id');
    const rawWatchList = $watchFinder.attr('customer-save-watch-list');
    const rawTags = $watchFinder.attr('customer-current-tags') || '';
    let existingTags = rawTags.split(',').map(tag => tag.trim()).filter(Boolean);
    // console.log("🧩 Existing Tags:", existingTags);
  
    let current = safeParseJSON(rawWatchList, []);
    // ✅ Filter out any invalid data like strings (e.g., "[]")
    current = current.filter(item => typeof item === 'object' && item !== null && !Array.isArray(item));
  
    const alreadyExists = current.some(watch =>
      watch.brand === watchData.brand &&
      watch.model === watchData.model &&
      watch.collection === watchData.collection &&
      watch.identifier === watchData.identifier &&
      watch.reference === watchData.reference
    );
  
    if (alreadyExists) return;
  
    current.unshift(watchData);
    if (current.length > 50) {
      const removed = current.slice(50);
    //   console.log("🗑️ Removing old watches:", removed);
      current = current.slice(0, 50);
    }
  
    // ✅ Ensure only valid objects saved
    current = current.filter(item => typeof item === 'object' && item !== null && !Array.isArray(item));
    $watchFinder.attr('customer-save-watch-list', JSON.stringify(current));
  
    const currentTagSet = new Set();
    current.forEach(watch => {
      if (watch.brand) currentTagSet.add(`sf_brand_${watch.brand.toLowerCase()}`);
      if (watch.model) currentTagSet.add(`sf_model_${watch.model.toLowerCase()}`);
      if (watch.collection) currentTagSet.add(`sf_collection_${watch.collection.toLowerCase()}`);
      if (watch.identifier) currentTagSet.add(`sf_id_${watch.identifier.toLowerCase()}`);
      if (watch.reference) currentTagSet.add(`sf_ref_${watch.reference.toLowerCase()}`);
    });
  
    // Handle watch count range tags
    for (let i = 1; i <= 50; i += 5) {
      const upper = Math.min(i + 4, 50);
      currentTagSet.delete(`sf_${i}-${upper}_watches`);
    }
  
    if (current.length > 0) {
      const lowerBound = Math.floor((current.length - 1) / 5) * 5 + 1;
      const upperBound = Math.min(lowerBound + 4, 50);
      currentTagSet.add(`sf_${lowerBound}-${upperBound}_watches`);
    }
  
    const newTags = Array.from(currentTagSet).filter(tag => !existingTags.includes(tag));
  
    const isRemovableTag = tag =>
      tag !== 'sf_saved_watch_strap_pairing' && // Protect this tag from removal
      (tag.startsWith('sf_brand_') ||
      tag.startsWith('sf_model_') ||
      tag.startsWith('sf_collection_') ||
      tag.startsWith('sf_id_') ||
      tag.startsWith('sf_ref_') ||
      (tag.startsWith('sf_') && tag.endsWith('_watches')));
  
    const removeTags = existingTags.filter(
      tag => isRemovableTag(tag) && !currentTagSet.has(tag)
    );
  
    const updatedTagSet = new Set([...existingTags, ...newTags]);
    removeTags.forEach(tag => updatedTagSet.delete(tag));
  
    $watchFinder.attr('customer-current-tags', Array.from(updatedTagSet).join(','));
  
    // ✅ Debug logs
    // console.log("🧩 New Tags to Add:", newTags);
    // console.log("❌ Tags to Remove:", removeTags);
    // console.log("🧑‍💼 Customer ID:", customerID);
    // console.log("⌚ Updated Watch List:", current);
    // console.log("🧩 Final Tags:", Array.from(updatedTagSet));
  
    const triggeredAt = getSingaporeTimestamp();
    // ✅ Send to webhook
    $.ajax({
      url: "https://webhooks.mechanic.dev/411d70c6-afc5-463b-9db8-583a633f213a",
      method: "POST",
      contentType: "application/json",
      data: JSON.stringify({
        customer_id: customerID,
        triggered_at: triggeredAt,
        watches: current,
        tags: Array.from(updatedTagSet)
      }),
    }).fail((error) => {
      console.error("❌ Error submitting watch data:", error);
    });
  
    // ✅ UI Card Update
    if ($('#_jscSavedWatchesList_display').length > 0) {

      const html = `
      <div class="jsc-year-img-item cursor columns carousel__slide small-6 medium-6 large-6" data-brand="${watchData.brand}" data-model="${watchData.model}" data-identifier="${watchData.identifier}" data-collection="${watchData.collection}" data-reference="${watchData.reference}">
        <div class="product-card text-left product-card--content-spacing-true product-card--border-false">  
          <a href="${watchData.url}"> 
              <div class="jsc-year-img">
                <img class="no-blur product-secondary-image lazyautosizes ls-is-cached lazyloaded" src="${watchData.watchImage}" alt="${watchData.brand} ${watchData.collection} ${watchData.reference}" />
              </div>
          </a>

          <div class="jsc-sf-product-card-save-watch" onclick='removeFromWatchList(${JSON.stringify(watchData)}, this)'>  
            <div class="sf-save-watch-button">
              <span class="sf-save-watch-icon">
                <img src="https://cdn.shopify.com/s/files/1/0054/9040/9585/files/tick-circle.svg?v=1760404794" width="40" height="40" alt="Saved">
              </span>
            </div>
          </div>

            <div class="product-card-info " style="background-color: #fff;">
              <a href="${watchData.url}">
                <div class="fontWeight-6" style="font-size: 15px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;max-width: 100%;">${watchData.model}</div>
                  <div style="margin-top: 10px;font-size: 13px; color: #7E7E7E;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;max-width: 100%;">Reference: ${watchData.reference}}</div>
              </a>
                                            
            </div>
        </div>
      </div>                            
    `;

      $('#_jscSavedWatchesList_display').find('jsc-sf-year-reference-img').find('.jsc-year-img-items-wrapper').prepend(html);
      $('#_jscSavedWatchesList_display').show();
      $('#_jscSavedWatchesList_na').hide();
    }

    // apped notification popup
    const $snackbar = $('#jsc-snackbar');
    $snackbar.addClass('show');

    setTimeout(function () {
      $snackbar.removeClass('show');
    }, 3000);
    
    // Update icons in Strap Finder tab for logged-in users
    updateStrapFinderTabIcons();
  };
  
  
  
  
  
  
  

// Function to update pagination index
updatePaginationIndex = (totalPage, activePage, htmlArray) => {
    const paginationContainer = $('#jsc-pagination-container');
    const paginationPages = paginationContainer.find('.jsc-pagination-pages');
    paginationPages.children().remove();
    paginationPages.removeClass('add-border');
    // Check if htmlArray has more than 8 elements
    if (htmlArray.length > 8){
      // Loop through the total number of pages
      for (let index = 1; index <= totalPage; index++) {
          // If it's the active page, add a current page class
          if (index === activePage) {
              paginationPages.addClass('add-border');
              paginationPages.append(`<span class="jsc-currentPage jsc-pagination-index m-l-10 m-r-10">${index}</span>`);
          } else {
              // Add pagination index with onclick function to paginate
              paginationPages.addClass('add-border');
              paginationPages.append(`<span class="jsc-pagination-index cursor m-l-10 m-r-10 " onclick="paginate('${htmlArray.join('---')}',${index})">${index}</span>`);
          }
      }
    }
  };


  // Function to paginate and load new li elements
paginate = (htmlString, pageIndex) => {
    $('.jsc-reinit-year-list').children().remove();
    $('jsc-year-list').show();
    const galleryContainer = $('jsc-year-reference-img');
    const htmlArray = htmlString.split('---');
    const isFromPaginate = true;
  
    // Remove existing li elements and pagination
    galleryContainer.children().remove();
    $('.jsc-pagination-pages').children().remove();
  
    // Load new li elements with pagination
    loadTableRow(htmlArray, pageIndex, isFromPaginate);
  };

populateInfoHtml = (reference) => {
    // Check if cachedWatchDb is available
    if (!cachedWatchDb || !Array.isArray(cachedWatchDb)) {
        console.warn('⚠️ cachedWatchDb is not available yet, skipping populateInfoHtml');
        return;
    }
    var sfInfoBrand = localStorage.getItem('brand');
    if (sfInfoBrand && !sfBrandLoaded(sfInfoBrand)) { sfLoadBrand(sfInfoBrand).then(function(){ populateInfoHtml(reference); }); return; }

    // Convert the model to a number if it's a string
    var referenceToMatch = isNaN(reference) ? reference : parseFloat(reference);

    // Filter data based on the 'brand'
    var filteredData = cachedWatchDb.filter(function(item) {
        return item.status === 1 && item.reference === referenceToMatch;
    });
            
    var infoUlElement1 = $('.placeholder-details .case-diameter');
    var infoUlElement2 = $('.placeholder-details .case-lug-distance');
    var infoUlElement4 = $('.placeholder-details .case-lug-width');
    var infoUlElement5 = $('jsc-year-placeholder').find('.year-img');

    var caseDiameter = filteredData.map(item => item.caseDiameter);
    var caseLugDistance = filteredData.map(item => item.lugToLugDistance);
    var caseLugWidth = filteredData.map(item => item.lugWidth);
    var caseImage = filteredData.map(item => item.image);

    $('.placeholder-info').css('visibility','visible');
            
    infoUlElement5.attr('src',caseImage);
    infoUlElement5.show();

    infoUlElement1.text(caseDiameter ? caseDiameter : 'NA');
    infoUlElement2.text(caseLugDistance ? caseLugDistance : 'NA');
    infoUlElement4.text(caseLugWidth ? caseLugWidth : 'NA');
 } 
 
 loadBrandOption = (getBrandLocalStorage) => {
    // Brands come from the lightweight index, not the catalog
    if (!sfIndex || !sfIndex.brands) {
        console.warn('⚠️ index is not available yet, skipping loadBrandOption');
        return;
    }

    const brandPopulateMap = {};
    sfIndex.brands.forEach(function (b) {
        if (b.populate && b.populate > 0) brandPopulateMap[b.name] = b.populate;
    });

    const popularBrands = Object.keys(brandPopulateMap)
        .sort((a, b) => brandPopulateMap[a] - brandPopulateMap[b])
        .slice(0, 10);

    const allBrands = sfIndex.brands.map(function (b) { return b.name; });

    // Step 5: Build list with sections
    const brandUlElement = $('#jsc-brand .custom-select__listbox');

    const createOptionLi = (brand) => {
        const handleizedBrand = handleizedString(brand);
        const isSelected = brand === getBrandLocalStorage;
        return `<li class="custom-select--item custom-select__option js-option" id="jsc-brand-${handleizedBrand}" data-value="${brand}" onclick="selectOption(this,'brand')" ${isSelected ? 'aria-selected="true"' : 'aria-selected="false"'}>
            <span class="${isSelected ? 'custom-select--active' : ''}">${brand}</span>
        </li>`;
    };

    const top10Header = `<li class="custom-select--item-top-brand custom-select--item custom-select__option js-option fontWeight-6">Top Brands</li>`;
    const top10Options = popularBrands.map(createOptionLi);

    const allBrandsHeader = `<li class="custom-select--item-top-brand custom-select--item custom-select__option js-option fontWeight-6">All Brands</li>`;
    const allOptions = allBrands.map(createOptionLi); 

    const finalList = [top10Header, ...top10Options, allBrandsHeader, ...allOptions];

    brandUlElement.html(finalList.join(''));
}


loadModelOption = (brand, isPageType) => {
      // Call the function to populate the model HTML
      var getModelLocalStorage = localStorage.getItem('model');
      populateModelHtml(brand, getModelLocalStorage, isPageType);
  
      // Reset model and engine options
      resetModelOption();
  
      // Reset local storage
      setLocalStorage('model', '');
      setLocalStorage('reference', '');
  
}

loadReferenceOption= (brand,model) => {
    // Call the function to populate the model HTML
    populateReferenceHtml(brand,model);
  
    // Reset reference and engine options
    resetReferenceOption();

    setLocalStorage('reference', '');
}

loadEngineOption = (model,isPageType,brand) => {
    // Fetch JSON data from the URL
    if(brand && !model){
        populateReferenceImageHtmlByBrand(brand,isPageType);
    }else{
        populateReferenceImageHtml(model,isPageType,brand);
    }
 
    // reset local storage
    setLocalStorage('reference', '');
}

selectOption = (e, key) => {
    var _this = $(e);
    var value = _this.attr('data-value');
    // $('#Watch-Finder--Drawer').removeClass('active');
    $('.box.jsc-watch-finder--clear').show();
    $('.box.jsc-watch-finder--smart-search').show();
    $('jsc-reinit-year-list').hide();
    $('jsc-year-list').show();
    
    // Set Local storage
    setLocalStorage(key, value);

    // Delugs: selection logging
    if (value) {
        if (key == 'brand') sfLogSelection('brand_selected', value, '', '');
        else if (key == 'model') sfLogSelection('collection_selected', null, value, '');
        else if (key == 'reference') sfLogSelection('reference_selected', null, null, value);
    }

    var isPageType =  $('jsc-watch-finder--drop-down').attr('sfPageType');

    // Enable model option
    if (key == 'brand') {
        setLocalStorage('model', '');
    // Replace selected value
    var brandValue = value ? "Brand: " + value : "-- Select Brand --";
    _this.closest('.jsc-custom-select').find('.custom-select--button input').attr('placeholder',brandValue);
    _this.closest('.jsc-custom-select').find('.custom-select--button input').val(brandValue);

       var getModelLocalStorage = localStorage.getItem('model');
       loadModelOption(value);
       loadReferenceOption(value);
       loadEngineOption(getModelLocalStorage,isPageType,value);
       $('jsc-year-right-wrapper').hide(); 
       $('jsc-year-wrapper').hide();
       $('finder-paginate-facet').text();
       $('#jsc-brand').removeClass('custom-select--active');

       $('jsc-watch-finder-content').addClass('show-year');
       $('jsc-year-wrapper').show();
       $('jsc-year-right-wrapper').show();
       $('jsc-year-reference-img').show();
       
       // Clear smart search text and results
       clearSmartSearch();
    } 
    
    // Display Result
    if (key == 'model') {
        // Replace selected value
        var brandValue = value ? "Collection: " + value : "-- Select Collection --";
        _this.closest('.jsc-custom-select').find('.custom-select--button input').attr('placeholder',brandValue);
        _this.closest('.jsc-custom-select').find('.custom-select--button input').val(brandValue);

        $('#jsc-model ul li').removeClass('active-model');
        _this.addClass('active-model');
        var getBrandLocalStorage = localStorage.getItem('brand');

        if ($('jsc-watch-finder--drop-down').length > 0) { // only for watch finder template
            initLoader();
            loadEngineOption(value,isPageType,getBrandLocalStorage);
        }else{
            loadReferenceOption(getBrandLocalStorage,value);
        }
        setPlaceholder();
    
        $('jsc-watch-finder-content').addClass('show-year');
        $('jsc-year-wrapper').show();
        $('jsc-year-right-wrapper').show();
        $('jsc-year-reference-img').show();
        $('#jsc-model').removeClass('custom-select--active');
        
        // Clear smart search text and results
        clearSmartSearch();
    }
}


setPlaceholder = () => {
    var getBrandLocalStorage = localStorage.getItem('brand');    
    $('.placeholder-brand-name').text(getBrandLocalStorage);
    $('.placeholder-info').css('visibility','hidden');    
}


resetBrandOption = () => {
    $('#jsc-brand .custom-select--button .jsc-brand-search').attr('placeholder','-- Select Brand --');
    $('#jsc-brand .custom-select--button .jsc-brand-search').text('');
    $('#jsc-brand .custom-select--button .jsc-brand-search').val('');
    $('#jsc-brand input').removeClass('jsc-placeholder-black-color');
}

resetModelOption = () => {
    $('#jsc-model .custom-select--button .jsc-model-search').attr('placeholder','-- Select Model --');
    $('#jsc-model .custom-select--button .jsc-model-search').text('');
    $('#jsc-model .custom-select--button .jsc-model-search').val('');
    $('#jsc-model input').removeClass('jsc-placeholder-black-color');
}

resetReferenceOption = () => {
    $('#jsc-reference .custom-select--button .jsc-reference-search').attr('placeholder','-- Select Reference --');
    $('#jsc-reference .custom-select--button .jsc-reference-search').text('');
    $('#jsc-reference .custom-select--button .jsc-reference-search').val('');
}

setLocalStorage = (key, value) => {
    localStorage.setItem(key, value);
}

onloadPopulateWatchFilterFromLocalStorage = (getBrandLocalStorage,getModelLocalStorage) => { 
       if (getBrandLocalStorage) {
          // Load Model option if Brand is in local storage
          populateModelHtml(getBrandLocalStorage, getModelLocalStorage);
          var brandValue = getBrandLocalStorage ? "Brand: " + getBrandLocalStorage : "-- Select Brand --";
          $('#jsc-brand .custom-select--button .jsc-brand-search').attr('placeholder',brandValue);
          $('.box.jsc-watch-finder--clear').show();
          $('.box.jsc-watch-finder--smart-search').show();
          
       }
 
       if (getModelLocalStorage) {
        var brandValue = getModelLocalStorage ? "Collection: " + getModelLocalStorage : "-- Select Collection --";
          $('#jsc-model .custom-select--button .jsc-model-search').attr('placeholder',brandValue);
          $('.box.jsc-watch-finder--clear').show();
          $('.box.jsc-watch-finder--smart-search').show();
       }
}

onloadPopulateReferenceFilterFromLocalStorage = (getBrandLocalStorage,getModelLocalStorage,getReferenceLocalStorage) => { 
    if (getBrandLocalStorage && getModelLocalStorage) {
        // Load reference option if Brand and Model is in local storage
        populateReferenceHtml(getBrandLocalStorage,getModelLocalStorage,getReferenceLocalStorage);
        var referenceValue = "Reference: " + getReferenceLocalStorage;
        if (getReferenceLocalStorage) {
            $('#jsc-reference .custom-select--button .jsc-reference-search').attr('placeholder',referenceValue);
         }
     }

}
onclickBrandDropdown = () => {
    $("#jsc-model").removeClass('custom-select--active');
}

onclickModelDropdown = () => {  
    $("#jsc-brand").removeClass('custom-select--active');
}


onclickReferenceDropdown = () => {  
    $("#jsc-brand").removeClass('custom-select--active');
    $("#jsc-model").removeClass('custom-select--active');
}

onclickBrandInput = () => {
    $("#jsc-model").removeClass('custom-select--active');
    $("#jsc-reference").removeClass('custom-select--active');

    var getModelLocalStorage = localStorage.getItem('model');
    if (getModelLocalStorage){
     $('#jsc-model input').addClass('jsc-placeholder-black-color');
    }

    $('#jsc-brand .custom-select--list ul li').each(function() {
        $(this).show();
    });
    $('#jsc-brand').addClass('custom-select--active');
    $('#jsc-brand input').removeClass('jsc-placeholder-black-color');
    $('#jsc-brand input').val('');
}

onclickModelInput = () => {
    // Hide brand dropdown
    $("#jsc-brand").removeClass('custom-select--active');
    $("#jsc-reference").removeClass('custom-select--active');
    $('#jsc-model .custom-select--list ul li').each(function() {
        $(this).show();
    });
    $('#jsc-model').addClass('custom-select--active');
    $('#jsc-model input').removeClass('jsc-placeholder-black-color');
    $('#jsc-model input').val('');
}

onclickReferenceInput = () => {
    // Hide reference dropdown
    $("#jsc-brand").removeClass('custom-select--active');
    $("#jsc-model").removeClass('custom-select--active');

    $('#jsc-reference .custom-select--list ul li').each(function() {
        $(this).show();
    });

    $('#jsc-reference').addClass('custom-select--active');
    $('#jsc-reference input').val('');
}

brandFilterFunction = (e) => {
    // console.log('brandFilterFunction');
    var filter = $(e).val().toUpperCase();
    $('#jsc-brand').addClass('custom-select--active');

    var ulElement = $('#jsc-brand .custom-select--list ul');
    ulElement.show();

    $('#jsc-brand .custom-select--list ul li').each(function() {
        var txtValue = $(this).text().toUpperCase();
        if (txtValue.indexOf(filter) > -1) {
            $(this).show();
        } else {
            $(this).hide();
        }
    });

       // Check if there are any visible list items
       var checkLiEle = ulElement.find('li:visible');
       if (checkLiEle.length === 0) {
           ulElement.hide(); // Hide the <ul> element if no visible list items
       } else {
           ulElement.show(); // Show the <ul> element if there are visible list items
       }
}

modelFilterFunction = (e) => {
    // console.log('modelFilterFunction');
    var filter = $(e).val().toUpperCase();
    $('#jsc-model').addClass('custom-select--active');

    var ulElement = $('#jsc-model .custom-select--list ul');
    ulElement.show();

    $('#jsc-model .custom-select--list ul li').each(function() {
        var txtValue = $(this).text().toUpperCase();
        if (txtValue.indexOf(filter) > -1) {
            $(this).show();
        } else {
            $(this).hide();
        }
    });

       // Check if there are any visible list items
       var checkLiEle = ulElement.find('li:visible');
       if (checkLiEle.length === 0) {
           ulElement.hide(); // Hide the <ul> element if no visible list items
       } else {
           ulElement.show(); // Show the <ul> element if there are visible list items
       }
}

referenceFilterFunction = (e) => {
    // console.log('referenceFilterFunction');
    var filter = $(e).val().toUpperCase();
    $('#jsc-reference').addClass('custom-select--active');
    // $('#jsc-reference input').removeClass('jsc-placeholder-black-color');

    var ulElement = $('#jsc-reference .custom-select--list ul');
    ulElement.show();

    $('#jsc-reference .custom-select--list ul li').each(function() {
        var txtValue = $(this).text().toUpperCase();
        if (txtValue.indexOf(filter) > -1) {
            $(this).show();
        } else {
            $(this).hide();
        }
    });

       // Check if there are any visible list items
       var checkLiEle = ulElement.find('li:visible');
       if (checkLiEle.length === 0) {
           ulElement.hide(); // Hide the <ul> element if no visible list items
       } else {
           ulElement.show(); // Show the <ul> element if there are visible list items
       }
}

toggleBrandDropdown = () => {
    $("#jsc-brand").toggleClass('custom-select--active');
}

toggleModelDropdown = () => {
    $("#jsc-model").toggleClass('custom-select--active');
}

toggleReferenceDropdown = () => {
    $("#jsc-reference").toggleClass('custom-select--active');
}

backToYearImg = () => {
   var list =  $('#jsc-model .custom-select--list ul li');
   var model = localStorage.getItem('model');
   list.each(function(){
        if ($(this).attr('data-value') == model){
            $(this).click();
        }
    });  
}

disabledAllSelection = () => {
    // Model
    $('#jsc-model .custom-select__listbox').html(blankLi);;
 
    // reset local storage
    setLocalStorage('brand', '');
    setLocalStorage('model', '');
    setLocalStorage('reference', '');
    
}

clearSelection = () => {
    resetBrandOption();
    resetModelOption();

    $('finder-paginate-facet').text();
    $('jsc-year-right-wrapper').hide();
    // $('.box.jsc-watch-finder--clear').hide();
    // $('.box.jsc-watch-finder--smart-search').hide();
    $('jsc-watch-finder-content').removeClass('show-year');
    
    var paginationContainer = $('#jsc-pagination-container');
    var paginationPages = paginationContainer.find('.jsc-pagination-pages');
    paginationPages.children().remove();
    paginationPages.removeClass('add-border');

    $('jsc-year-reference-img').children().remove();
    disabledAllSelection();
    // disabledeWatchBtn();
    
    // Clear smart search text and results
    const searchInput = document.getElementById('jsc-smart-search-input');
    if (searchInput) {
        // Clear the input value completely
        searchInput.value = '';
        searchInput.textContent = '';
        searchInput.innerText = '';
        
        // Reset placeholder using multiple methods
        searchInput.setAttribute('placeholder', 'Search');
        $('#jsc-smart-search-input').attr('placeholder', 'Search');
        $('#jsc-smart-search-input').val('');
        
        // Force a complete reset
        // searchInput.blur();
        searchInput.focus();
        
        // Trigger input event to ensure any listeners are notified
        searchInput.dispatchEvent(new Event('input', { bubbles: true }));
        searchInput.dispatchEvent(new Event('change', { bubbles: true }));
        
        console.log('🔍 Search input cleared, value:', searchInput.value, 'placeholder:', searchInput.placeholder);
    }
    hideSearchResults();
    clearSearchResults();
}

onloadWatchButton = (getBrandLocalStorage,getModelLocalStorage) => {
   $('.placeholder-info').css('visibility','hidden');

   if (getBrandLocalStorage && getModelLocalStorage){ 
        populateReferenceImageHtml(getModelLocalStorage);
        $('jsc-watch-finder-content').addClass('show-year');
        $('jsc-year-right-wrapper').show();
    }else if (getBrandLocalStorage && !getModelLocalStorage) {
        populateReferenceImageHtmlByBrand(getBrandLocalStorage);
        $('jsc-watch-finder-content').addClass('show-year');
        $('jsc-year-right-wrapper').show();
    }else{
        $('jsc-watch-finder-content').removeClass('show-year');
        $('jsc-year-right-wrapper').hide();
    }
}

showWatchInfo = () => {
    var brandName = localStorage.getItem('brand');
    $('.placeholder-details .placeholder-brand-name').text(brandName);
    $('jsc-watch-finder--description').hide();
}


enableWatchBtn = () => { 
    $('.jsc-search-watch-button').attr('disabled',false);
}

destroyYearArticleSlider = () =>{
    $('.jsc-reinit-year-article').flickity();
    $('.jsc-reinit-year-article').flickity('destroy');
  }


triggerMobilePopup = () =>{
    if($(window).width() < 1100){
        $('#PopupModal-watchfinder').attr('open',true)
    }
}
constructParamUrl = (index, e,isPageType) => {
    var $this = $(e);
    var $input = $this.find('input');
    
    clearTabSessionStorage();

    // Get brand, model and year, remove spaces
    var $brand = $input.attr('brand').replace(/\s+/g, '');
    var $model = $input.attr('watch').replace(/\s+/g, '');
    var $year = $input.attr('year-ref').replace(/\s+/g, '');
    var $brandSpecificPage = $input.attr('brand-specific-page');
    var $modelLandingPage = $input.attr('model-landing-page');

    if (isPageType == 'brand'){
        if ($brandSpecificPage) {
            var findastrapLink = $brandSpecificPage;
        }else{
            var findastrapLink = window.location.pathname;
        }
    }else if (isPageType == 'model'){
        var findastrapLink = $modelLandingPage;
    }else {
        /* Prefer model landing page if available (links to dedicated SF Lite page) */
        if ($modelLandingPage && ($modelLandingPage.includes('/pages') || $modelLandingPage.includes('/products'))) {
            var findastrapLink = $modelLandingPage;
        } else {
            /* Try constructing strap-model page URL: /pages/straps-{brand}-{model}-{reference} */
            var hBrand = ($input.attr('brand') || '').toLowerCase().trim().replace(/[^a-z0-9\s-]/g,'').replace(/\s+/g,'-').replace(/-+/g,'-');
            var hModel = ($input.attr('model') || '').toLowerCase().trim().replace(/[^a-z0-9\s-]/g,'').replace(/\s+/g,'-').replace(/-+/g,'-');
            var hRef = ($input.attr('year-ref') || '').toLowerCase().trim().replace(/[^a-z0-9\s-]/g,'').replace(/\s+/g,'-').replace(/-+/g,'-');
            var candidatePage = '/pages/straps-' + hBrand + '-' + hModel + '-' + hRef;
            /* Check if the strap-model page exists via a quick HEAD request */
            var xhr = new XMLHttpRequest();
            xhr.open('HEAD', candidatePage, false);
            try {
                xhr.send();
                if (xhr.status === 200) {
                    var findastrapLink = candidatePage;
                } else {
                    var findastrapLink = '/pages/' + $('.jsc-watch-finder').attr('sf-page');
                }
            } catch(e) {
                var findastrapLink = '/pages/' + $('.jsc-watch-finder').attr('sf-page');
            }
        }
    }

    // Construct URL — skip params for dedicated landing pages
    var finalUrl;
    if (findastrapLink.includes("/pages/straps-") || findastrapLink.includes("/products/")) {
      finalUrl = findastrapLink;
    } else {
      finalUrl = `${findastrapLink}?brand=${$brand}&collection=${$model}&reference=${$year}`;
    }
    // Save to recently viewed (store the resolved destination so the card can navigate there later)
    try { var _rb = $input ? ($input.attr("brand") || $brand) : $brand; var _rc = $input ? ($input.attr("watch") || $model) : $model; saveRecentWatch(_rb || "", _rc || "", $year || "", $input ? $input.attr("year-src") || "" : "", finalUrl); } catch(e) {}
    window.location.href = finalUrl;

}

clearTabSessionStorage = () => {
  sessionStorage.removeItem('selectedStrapTab');
  sessionStorage.removeItem('selectedFilterType');
  sessionStorage.removeItem('selectedFilterCollection');
  sessionStorage.removeItem('selectedStrapMaterial');
}

constructYearWrapper = (index,e) => {
    var $this = $(e);
  if (!$this.find('.product-card').hasClass('border-active')) {

    $('jsc-watch-finder .product-card').removeClass('border-active');
    $this.find('.product-card').addClass('border-active');

    var wrapper = $('.jsc-reinit-year-list');
    wrapper.children().remove();
    $('.article-slider-wrapper').remove();
    $('jsc-year-list').hide();

    $('jsc-reinit-year-list').show();
    $('jsc-year-list').hide();


        var $this_input = $this.find('input');
        destroyYearArticleSlider();
        // Get the image source from the attribute
        var img_src = $this_input.attr('year-src');
        var case_diameter = $this_input.attr('case-diameter');
        var lug_distance = $this_input.attr('lug-to-lug-distance');
        var lug_width = $this_input.attr('lug-width');
        var article_urls = $this_input.attr('article-urls');

        // Create a new div for each element
        const newDiv = $('<div>').addClass('jsc_carousel__slide').attr('data-index',index);

        // Append an image to the new div
        newDiv.append($('<img>').attr('src', img_src));

        // Create the placeholder-details div
        var placeholderDetailsDiv = $('<div>').addClass('placeholder-details');

        // Create the brand-name and brand-info divs
        var brandName = localStorage.getItem('brand');
        var referenceName  = localStorage.getItem('reference');
        var brandNameDiv = $('<div>').addClass('brand-name fontWeight-6 m-b-5 text-left').text(brandName);
        var referenceDiv = $('<div>').addClass('reference-name text-left').text("Reference: " + referenceName);
        
         var brandInfoDiv = $('<span>').addClass('brand-info text-left m-r-5').text('');
        brandInfoDiv.append("Case size: " + (case_diameter ? case_diameter + "mm," : "-"));

        var lugWidthBrandInfoDiv = $('<span>').addClass('brand-info text-left').text('');
        lugWidthBrandInfoDiv.append("Lug width: " + (lug_width ? lug_width + "mm" : "-"));

        var lugBrandInfoDiv = $('<div>').addClass('brand-info text-left').text('');
        lugBrandInfoDiv.append("Lug-to-lug: " + (lug_distance ? lug_distance + "mm" : "-"));

        var infoBtnWrapperDiv = $('<div>').addClass('info-btn-wrapper');

        // var findStrapButton = $('<div>').attr('onclick', 'findStrap()').addClass('button accent').text('Find A Strap');
        var recommendStrapButton = $('<div>').attr('onclick', 'findStrap("recommended")').addClass('button accent').text('Shop Recommended Straps');
        var viewAllStrapButton = $('<div>').attr('onclick', 'findStrap("all")').addClass('button').text('View All Compatible Straps');
 
        infoBtnWrapperDiv.append(recommendStrapButton);
        infoBtnWrapperDiv.append(viewAllStrapButton);
        placeholderDetailsDiv.append(brandNameDiv, referenceDiv, brandInfoDiv, lugWidthBrandInfoDiv, lugBrandInfoDiv);

        newDiv.append(placeholderDetailsDiv);
        newDiv.append(infoBtnWrapperDiv);

        wrapper.append(newDiv);

        constructBlogSlider(article_urls);
  }
}

constructBlogSlider = (urls) => {
    let urlArray = urls.split('>').map(url => url.trim()).filter(url => url !== "");
    var sliderWrapper = $('<div>').addClass('article-slider-wrapper');
    var ajaxCalls = []; 

    urlArray.forEach(url => {
        let cleanUrl;
        try {
            cleanUrl = new URL(url).pathname;
        } catch (e) {
            cleanUrl = url;
        }

        let ajaxCall = $.ajax({
            url: cleanUrl,
            cache: false,
            success: function(response) {
                var title = $(response).find('h1').text().trim();
                var pageTitle = $(response).find('title').text().trim();
                pageTitle = pageTitle.replace(/\s*[-–]\s*Delugs$/, ''); 
                var postDate = $(response).find('#main-content .post-meta-wrapper time').text().trim(); 
                var thirdParagraph = $(response).find('#main-content .rte p').eq(2).text().trim();
                var preview = thirdParagraph.substring(0, 110) + '...';
                var featuredImage = $(response).find('.blog-post-detail--wrapper .featured-image img').attr('src');

                var articleDiv = $('<div>').addClass('article-slide');

                if (title) {
                    var titleElement = $('<h6 class="fontWeight-6 text-center">').text(title);
                    articleDiv.append(titleElement);
                }

                var contentWrapper = $('<div>').addClass('content-wrapper').css('padding', '15px');

                if (featuredImage) {
                    var imgWrapper = $('<div>').addClass('featured-image m-b-10');
                    var img = $('<img>').attr('src', featuredImage).attr('alt', title).attr('width', '440').attr('height', '300');
                    imgWrapper.append(img);
                    contentWrapper.append(imgWrapper);
                }

                var datelement = $('<div class="article-date m-b-10" style="color:#8888">').text(postDate);
                contentWrapper.append(datelement);

                var pageTitleElement = $('<div class="page-title m-b-10 fontWeight-6" style="color:var(--color-accent)">').text(pageTitle);
                contentWrapper.append(pageTitleElement);

                var previewText = $('<div class="rte m-b-10">').text(preview);
                contentWrapper.append(previewText);

                var readMoreLink = $('<a class="m-b-10">').attr('href', url).attr('target', '_blank').text('Read more >').css('color', 'var(--color-accent)');
                contentWrapper.append(readMoreLink);

                articleDiv.append(contentWrapper);

                // Append articleDiv to sliderWrapper
                sliderWrapper.append(articleDiv);
            },
            error: function() {
                console.log("Failed to fetch blog article:", cleanUrl);
            }
        });

        ajaxCalls.push(ajaxCall);
    });

    $.when.apply($, ajaxCalls).done(function() {
  
        $('jsc-year-right-wrapper').append(sliderWrapper);

        $('.article-slider-wrapper').flickity({
            cellAlign: 'left',
            contain: true,
            wrapAround: true,
            autoPlay: 3000
        });
    });
};

initLoader = () => {
    var $html = `<div class="jsc-page-loading">
        <div class="jsc-spinner-container">
        <div class="jsc-spinner"></div>
        </div>
        </div>`;
    $('body').prepend($html);
}

removeLoader = () => {
    setTimeout(function(){
        $('.jsc-page-loading').remove();
    },2500);
}

findStrap = (type) => {

    localStorage.setItem('strapOnlyFilter', type);
    var findastrapLink = $('jsc-watch-finder').attr('sf-page');
    findastrapLink = '/pages/'+findastrapLink;
    var recommendCol = $('.jsc-year-img-items .border-active').parent().find('.jsc-year-img-data').attr('recommend-collection');;
    localStorage.setItem('recommendCol', recommendCol);

    var watchFace = $('.jsc-year-img-items .border-active').parent().find('.jsc-year-img-data').attr('watch-face');;
    localStorage.setItem('watchFace', watchFace);
    
    $('.brand-info').each(function() {
        var text = $(this).text(); 
        if (text.includes('Case size:')) {
          var caseDiameter = text.match(/[\d.]+/)[0];
          localStorage.setItem('caseDiameter', caseDiameter);
        }
      
        if (text.includes('Lug width:')) {
            var match = text.match(/[\d.]+/);
            if (match) { 
                var lugWidth = match[0]; 
                localStorage.setItem('lugWidth', lugWidth);
            } else {

                localStorage.setItem('lugWidth', '');
            }
        }
      
      });  

    window.location.href = findastrapLink;
}

// Simple function to preserve watch finder parameters
preserveWatchFinderParams = (url) => {
  const currentUrl = window.location.href;
  const hasBrandParam = currentUrl.includes('?brand=') || currentUrl.includes('&brand=');

  if (hasBrandParam) {
      // ---- Manual parse current window URL to preserve broken brand ----
      const originalQS = window.location.search.slice(1);
      const parts = originalQS.split('&');

      let brand = '';
      let collection = '';
      let reference = '';
      let i = 0;

      while (i < parts.length) {
          let part = parts[i];
          if (!part) { i++; continue; }

          const [key, ...rest] = part.split('=');
          let value = rest.join('=');

          if (key === 'brand') {
              brand = value || '';
              // Stitch consecutive parts without '=' (like '&S%C3%B6hne')
              let j = i + 1;
              while (j < parts.length && !parts[j].includes('=')) {
                  brand += '&' + parts[j];
                  j++;
              }
              i = j - 1; // skip stitched parts
          } else if (key === 'collection') {
              collection = value || '';
          } else if (key === 'reference') {
              reference = value || '';
          }
          i++;
      }

      const decodePlus = (s) => (s || '').replace(/\+/g, ' ');
      const safeDecode = (s) => {
          try { return decodeURIComponent(decodePlus(s)); }
          catch { return decodePlus(s); }
      };

      brand = safeDecode(brand).trim();
      collection = safeDecode(collection).trim();
      reference = safeDecode(reference).trim();

      // Build the new URL
      const params = [];
      if (brand) params.push(`brand=${encodeURIComponent(brand)}`);
      if (collection) params.push(`collection=${encodeURIComponent(collection)}`);
      if (reference) params.push(`reference=${encodeURIComponent(reference)}`);

      if (params.length) {
          const separator = url.includes('?') ? '&' : '?';
          const preservedUrl = `${url}${separator}${params.join('&')}`;
          return preservedUrl;
      } else {
          return url;
      }
  }

  // If no ?brand parameter, just navigate normally
  return url;
}

// Override the default link behavior for filters and pagination
document.addEventListener('DOMContentLoaded', function() {
  // Override filter links - only within collection section
  document.addEventListener('click', function(e) {
      // Check if clicked element is within the ProductGridContainer (collection section)
      const isWithinCollection = e.target.closest('#ProductGridContainer');
      
      // Check if we're on a watch finder page or collection page
      const isWatchFinderPage = window.location.pathname.includes('/collections/') &&
                               window.location.search.includes('brand=');
      
      // Check if clicked element is a filter link or pagination link
      const filterLink = e.target.closest('a[href*="filter."]');
      const paginationLink = e.target.closest('a[href*="page="]');
      const sortLink = e.target.closest('a[href*="sort_by="]');
      const paginationSpan = e.target.closest('.jsc-pagination-span');
      
      const isFilterLink = filterLink || paginationLink || sortLink || paginationSpan;
      
      // If it's a pagination span on a non-watch finder page, override the onclick to work normally
      if (paginationSpan && !isWatchFinderPage && !isWithinCollection) {
          // Get the URL from href or onclick
          const href = paginationSpan.getAttribute('href');
          let targetUrl = href;
          
          if (!targetUrl) {
              const onclick = paginationSpan.getAttribute('onclick');
              if (onclick) {
                  const match = onclick.match(/preserveWatchFinderParams\('([^']+)'/);
                  if (match) {
                      targetUrl = match[1];
                  }
              }
          }
          
          if (targetUrl) {
              window.location.href = targetUrl;
          }
          
          return;
      }
      
      // Only handle special cases for watch finder pages or collection sections
      if (isFilterLink && (isWithinCollection || isWatchFinderPage)) {
          let originalUrl;
          
          if (paginationSpan) {
              // For pagination spans, extract URL from href or onclick attribute
              const href = paginationSpan.getAttribute('href');
              if (href) {
                  originalUrl = href;
              } else {
                  // If no href, try to extract from onclick
                  const onclick = paginationSpan.getAttribute('onclick');
                  if (onclick) {
                      const match = onclick.match(/preserveWatchFinderParams\('([^']+)'/);
                      if (match) {
                          originalUrl = match[1];
                      }
                  }
              }
          } else {
              // For regular links
              const linkElement = e.target.closest('a');
              originalUrl = linkElement.href;
          }
          
          if (!originalUrl) {
              return;
          }
          
          e.preventDefault();
          const preservedUrl = preserveWatchFinderParams(originalUrl);
          window.location.href = preservedUrl;
      }
  });
  
  // Override form submissions for filters - only within collection section
  document.addEventListener('submit', function(e) {
      // Check if form is within the ProductGridContainer (collection section)
      const isWithinCollection = e.target.closest('#ProductGridContainer');
      
      if (!isWithinCollection) {
          return; // Exit early if not within collection section
      } 
      
      const isFilterForm = e.target.closest('form[action*="filter"]') || e.target.closest('form[action*="collection"]');
      
      if (isFilterForm) {
          e.preventDefault();
          const form = e.target;
          const formData = new FormData(form);
          const url = new URL(form.action || window.location.href);
          
          // Add form data to URL
          for (let [key, value] of formData.entries()) {
              url.searchParams.set(key, value);
          }
          
          const preservedUrl = preserveWatchFinderParams(url.toString());
          window.location.href = preservedUrl;
      }
  });
});

// Smart Search Functionality
initSmartSearch = () => {
    const searchInput = document.getElementById('jsc-smart-search-input');
    const resultsContainer = document.getElementById('smart-search-results');
    
    if (!searchInput || !resultsContainer || searchInput.dataset.sfSearchBound === 'true') return;
    searchInput.dataset.sfSearchBound = 'true';
    
    let searchTimeout;
    
    // Prevent zoom on mobile devices
    searchInput.addEventListener('focus', () => {
        // Force font size to prevent iOS Safari zoom
        searchInput.style.fontSize = '16px';
        searchInput.style.webkitTextSizeAdjust = '100%';
    });
    
    // Debounced search function
    searchInput.addEventListener('input', (e) => {
        console.log('🔍 Smart Search Input Event Triggered:', e.target.value);
        clearTimeout(searchTimeout);
        // Invalidate an older request immediately, including while debouncing or clearing.
        performSmartSearch._t = (performSmartSearch._t || 0) + 1;
        const query = e.target.value.trim();
        
        if (query.length < 2) {
            console.log('🔍 Query too short, clearing search results and year list');
            hideSearchResults();
            clearSearchResults();
            return;
        }
        
        console.log('🔍 Starting search for:', query);
        clearSearchResults();
        showSmartSearchStatus('Searching…');
        searchTimeout = setTimeout(() => {
            performSmartSearch(query);
        }, 300);
    });
    
    // Hide results when clicking outside
    document.addEventListener('click', (e) => {
        if (!e.target.closest('.smart-search-container')) {
            // Only hide if results are actually visible
            const resultsContainer = document.getElementById('smart-search-results');
            if (resultsContainer && resultsContainer.style.display === 'block') {
                hideSearchResults();
            }
        }
    });
    
    // Handle keyboard navigation
    searchInput.addEventListener('keydown', (e) => {
        const results = resultsContainer.querySelectorAll('.smart-search-result-item');
        const activeResult = resultsContainer.querySelector('.smart-search-result-item.active');
        
        if (e.key === 'ArrowDown') {
            e.preventDefault();
            if (activeResult) {
                activeResult.classList.remove('active');
                const next = activeResult.nextElementSibling;
                if (next) {
                    next.classList.add('active');
                } else {
                    results[0]?.classList.add('active');
                }
            } else {
                results[0]?.classList.add('active');
            }
        } else if (e.key === 'ArrowUp') {
            e.preventDefault();
            if (activeResult) {
                activeResult.classList.remove('active');
                const prev = activeResult.previousElementSibling;
                if (prev) {
                    prev.classList.add('active');
                } else {
                    results[results.length - 1]?.classList.add('active');
                }
            } else {
                results[results.length - 1]?.classList.add('active');
            }
        } else if (e.key === 'Enter') {
            e.preventDefault();
            if (activeResult) {
                activeResult.click();
            }
        } else if (e.key === 'Escape') {
            hideSearchResults();
            searchInput.blur();
        }
    });
};

// Fuzzy search algorithm
calculateFuzzyScore = (query, text) => {
    if (!query || !text) return 0;
    
    // Ensure both are strings
    const queryStr = String(query);
    const textStr = String(text);
    
    const queryLower = queryStr.toLowerCase();
    const textLower = textStr.toLowerCase();
    
    // Exact match gets highest score
    if (textLower === queryLower) return 100;
    
    // Starts with query gets high score
    if (textLower.startsWith(queryLower)) return 90;
    
    // Contains query gets medium score
    if (textLower.includes(queryLower)) return 70;
    
    // Fuzzy matching using Levenshtein distance - more strict
    const distance = levenshteinDistance(queryLower, textLower);
    const maxLength = Math.max(queryLower.length, textLower.length);
    const similarity = (maxLength - distance) / maxLength;
    
    // Only allow fuzzy matches if similarity is very high (80%+) and distance is small
    if (similarity >= 0.8 && distance <= 3) {
        return Math.max(0, similarity * 40); // Lower score for fuzzy matches
    }
    
    return 0; // No fuzzy match if not similar enough
};

// Levenshtein distance calculation
levenshteinDistance = (str1, str2) => {
    const matrix = [];
    
    for (let i = 0; i <= str2.length; i++) {
        matrix[i] = [i];
    }
    
    for (let j = 0; j <= str1.length; j++) {
        matrix[0][j] = j;
    }
    
    for (let i = 1; i <= str2.length; i++) {
        for (let j = 1; j <= str1.length; j++) {
            if (str2.charAt(i - 1) === str1.charAt(j - 1)) {
                matrix[i][j] = matrix[i - 1][j - 1];
            } else {
                matrix[i][j] = Math.min(
                    matrix[i - 1][j - 1] + 1,
                    matrix[i][j - 1] + 1,
                    matrix[i - 1][j] + 1
                );
            }
        }
    }
    
    return matrix[str2.length][str1.length];
};

// Normalize text for better matching
normalizeText = (text) => {
    // Convert to string and handle null/undefined values
    if (text === null || text === undefined) {
        return '';
    }
    
    const textStr = String(text);
    return textStr
        .toLowerCase()
        // Handle German umlauts and special characters
        .replace(/[àáâãäå]/g, 'a')
        .replace(/[èéêë]/g, 'e')
        .replace(/[ìíîï]/g, 'i')
        .replace(/[òóôõö]/g, 'o')
        .replace(/[ùúûü]/g, 'u')
        .replace(/[ç]/g, 'c')
        .replace(/[ñ]/g, 'n')
        .replace(/[ß]/g, 'ss')
        .replace(/[ö]/g, 'oe')
        .replace(/[ü]/g, 'ue')
        .replace(/[ä]/g, 'ae')
        // Handle common brand name variations
        .replace(/[&]/g, 'and')
        .replace(/[.]/g, '')  // Remove periods (A. Lange -> A Lange)
        .replace(/[''`]/g, '') // Remove apostrophes/quotes
        .replace(/[-]/g, ' ') // Convert hyphens to spaces
        .replace(/[^a-z0-9\s]/g, '') // Remove other special characters
        .replace(/\s+/g, ' ') // Normalize multiple spaces to single space
        .trim();
};

// Perform the smart search
// Delugs search v2: token-based cross-field matching ("rolex submariner" works),
// nickname dictionary, punctuation-insensitive references, demand-ranked ties.
var SF_NICKNAMES = {
  'moonwatch': ['speedmaster'], 'speedy': ['speedmaster'],
  'sub': ['submariner'], 'subs': ['submariner'],
  'pepsi': ['blro', '16710', '1675'], 'batman': ['blnr'], 'batgirl': ['blnr'],
  'hulk': ['116610lv'], 'kermit': ['16610lv', '126610lv'], 'starbucks': ['126610lv'],
  'smurf': ['116619'], 'sprite': ['126720'], 'rootbeer': ['126711', '126715', '16753'],
  'snowflake': ['sbga211', 'sbga413'], 'gs': ['grand seiko'],
  'pp': ['patek'], 'ap': ['audemars'], 'vc': ['vacheron'], 'fpj': ['journe'],
  'dj': ['datejust'], 'op': ['oyster perpetual'], 'exp': ['explorer'],
  'bb': ['black bay'], 'bb58': ['black bay', '79030'], 'bb54': ['black bay', '79000'],
  'turtle': ['srp77', 'srpe93', 'turtle'], 'samurai': ['srpb', 'samurai'],
  'alpinist': ['alpinist', 'spb121'], 'cocktail': ['cocktail', 'presage'],
  'aquanaut': ['aquanaut', '5167'], 'nautilus': ['nautilus', '5711'],
  'royaloak': ['royal oak'], 'at': ['aqua terra'], 'po': ['planet ocean'], 'smp': ['seamaster'],
  'navi': ['navitimer'], 'ff': ['fifty fathoms'], 'pam': ['panerai', 'pam'],
  'lum': ['luminor'], 'speedtimer': ['speedtimer'], 'monaco': ['monaco'], 'carrera': ['carrera']
};

showSmartSearchStatus = (message) => {
    var container = document.getElementById('smart-search-results');
    if (!container) return;
    container.setAttribute('role', 'status');
    container.setAttribute('aria-live', 'polite');
    container.textContent = message || '';
    container.style.padding = message ? '12px' : '';
    container.style.display = message ? 'block' : 'none';
};

performSmartSearch = (query) => {
    // Delugs: search runs server-side (/api/strap-finder/search) so the
    // browser never needs the full catalog. Token guard drops stale responses.
    var q = String(query || '').trim();
    if (q.length < 2) { displaySearchResults([]); return; }
    var myToken = (performSmartSearch._t = (performSmartSearch._t || 0) + 1);
    showSmartSearchStatus('Searching…');
    $.getJSON(sfApiBase + '/api/strap-finder/search', { q: q }).then(function (d) {
        if (myToken !== performSmartSearch._t) return;
        var sortedResults = (d && d.results) || [];
        try {
          clearTimeout(window.sfSearchLogTimer);
          window.sfSearchLogTimer = setTimeout(function(){
            sfLogSelection('search_query', '', '', '', { searchQuery: q, resultCount: (d && d.resultCount) || 0 });
          }, 1500);
        } catch (eSL) {}
        displaySearchResults(sortedResults);
    }).fail(function() {
        if (myToken !== performSmartSearch._t) return;
        clearSearchResults();
        showSmartSearchStatus('Search is temporarily unavailable. Please try again.');
    });
};

// Display search results
displaySearchResults = (results) => {
    console.log('🔍 displaySearchResults called with', results.length, 'results');
    
    if (results.length === 0) {
        console.log('🔍 No results, clearing year image list');
        // Clear the year image list when no results
        clearSearchResults();
        showSmartSearchStatus('No watches found. Try a brand, model, or another reference.');
        return;
    }
    showSmartSearchStatus('');
    
    // Skip dropdown, go directly to constructing year image list
    console.log('🔍 Constructing year image list from search results');
    constructSmartSearchYearImg(results);
};

// Hide search results
hideSearchResults = () => {
    console.log('🔍 hideSearchResults called');
    const resultsContainer = document.getElementById('smart-search-results');
    if (resultsContainer) {
        resultsContainer.style.display = 'none';
    }
};

// Clear smart search input and results
clearSmartSearch = () => {
    console.log('🔍 clearSmartSearch called');
    const searchInput = document.getElementById('jsc-smart-search-input');
    if (searchInput) {
        // Clear the input value completely
        searchInput.value = '';
        searchInput.textContent = '';
        searchInput.innerText = '';
        
        // Reset placeholder using multiple methods
        searchInput.setAttribute('placeholder', 'Search');
        $('#jsc-smart-search-input').attr('placeholder', 'Search');
        $('#jsc-smart-search-input').val('');
        
        // Force a complete reset
        // searchInput.blur(); // Removed to test mobile behavior
        
        console.log('🔍 Search input cleared, value:', searchInput.value, 'placeholder:', searchInput.placeholder);
    }
    hideSearchResults();
    
};

// Clear search results and reset UI to original state
clearSearchResults = () => {
    console.log('🔍 clearSearchResults called - resetting UI to original state');
    
    // Clear the year image list
    $('jsc-year-reference-img').children().remove();
    
    // Hide year wrapper sections
    $('jsc-watch-finder-content').removeClass('show-year');
    $('jsc-year-wrapper').hide();
    $('jsc-year-right-wrapper').hide();
    $('jsc-year-reference-img').hide();
    
    // Clear pagination
    var paginationContainer = $('#jsc-pagination-container');
    var paginationPages = paginationContainer.find('.jsc-pagination-pages');
    paginationPages.children().remove();
    paginationPages.removeClass('add-border');
};

// Handle smart search result selection
selectSmartSearchResult = (brand, collection, reference, identifier) => {
    console.log('🔍 selectSmartSearchResult called with:', { brand, collection, reference, identifier });
    // Set local storage
    setLocalStorage('brand', brand);
    setLocalStorage('model', collection);
    setLocalStorage('reference', reference);
    
    // Update UI
    const brandValue = brand ? "Brand: " + brand : "-- Select Brand --";
    $('#jsc-brand .custom-select--button .jsc-brand-search').attr('placeholder', brandValue);
    $('#jsc-brand .custom-select--button .jsc-brand-search').val(brandValue);
    $('#jsc-brand .custom-select--button .jsc-brand-search').addClass('jsc-placeholder-black-color');
    
    const modelValue = collection ? "Collection: " + collection : "-- Select Collection --";
    $('#jsc-model .custom-select--button .jsc-model-search').attr('placeholder', modelValue);
    $('#jsc-model .custom-select--button .jsc-model-search').val(modelValue);
    $('#jsc-model .custom-select--button .jsc-model-search').addClass('jsc-placeholder-black-color');

    
    // Load the watch data
    var isPageType = $('jsc-watch-finder--drop-down').attr('sfPageType');
    populateReferenceImageHtml(collection, isPageType, brand);
    
    // Show the year wrapper
    $('jsc-watch-finder-content').addClass('show-year');
    $('jsc-year-wrapper').show();
    $('jsc-year-right-wrapper').show();
    $('jsc-year-reference-img').show();
    
    // Hide search results
    hideSearchResults();
    
    // Clear search input
    document.getElementById('jsc-smart-search-input').value = '';
};

// Construct year image list from search results
constructYearImgFromSearchResults = (searchResults) => {
    console.log('🔍 constructYearImgFromSearchResults called with', searchResults.length, 'results');
    
    // Reset brand and model dropdowns since we're showing search results
    console.log('🔍 Resetting brand and model dropdowns for search results');
    resetBrandOption();
    resetModelOption();
    
    // Clear session storage
    setLocalStorage('brand', '');
    setLocalStorage('model', '');
    setLocalStorage('reference', '');

    
    // Convert search results to the format expected by loadTableRow
    // Each search result should be treated as a separate watch card
    const htmlArray = searchResults.map(item => {
        // Each reference gets its own card - don't group by watchImage
        const yearNumString = item.reference; // Single reference per card
        
        // Collect article handles (only if they exist)
        const articleHandles = [item.article1, item.article2, item.article3].filter(Boolean).join('>');
        
        // Return in the same format as the original loadTableRow function expects
        return `${yearNumString}|~|${item.watchImage}|~|${item.caseDiameter}|~|${item.lugToLugDistance}|~|${item.lugWidth}|~|${item.watchHeadImage}|~|${articleHandles}|~|${item.recommendedCollection}|~|${item.brand}|~|${item.collection}|~|${item.brandSpecificPage}|~|${item.model}|~|${item.modelLandingPage}|~|${item.identifier}`;
    });
    
    console.log('🔍 Constructed htmlArray for search results:', htmlArray);
    
    // Use the existing loadTableRow function to display the results
    var isPageType = $('jsc-watch-finder--drop-down').attr('sfPageType');
    loadTableRow(htmlArray, isPageType);
    
    // Show the year wrapper
    $('jsc-watch-finder-content').addClass('show-year');
    $('jsc-year-wrapper').show();
    $('jsc-year-right-wrapper').show();
    $('jsc-year-reference-img').show();
};

// Construct year image list specifically for smart search results
constructSmartSearchYearImg = (searchResults) => {
    console.log('🔍 constructSmartSearchYearImg called with', searchResults.length, 'results');
    
    // Reset brand and model dropdowns since we're showing search results
    console.log('🔍 Resetting brand and model dropdowns for search results');
    resetBrandOption();
    resetModelOption();
    
    // Clear session storage
    setLocalStorage('brand', '');
    setLocalStorage('model', '');
    setLocalStorage('reference', '');
    
    // Convert search results to the format expected by loadTableRow
    // Each search result should be treated as a separate watch card
    const htmlArray = searchResults.map(item => {
        // Each reference gets its own card - don't group by watchImage
        const yearNumString = item.reference; // Single reference per card
        
        // Collect article handles (only if they exist)
        const articleHandles = [item.article1, item.article2, item.article3].filter(Boolean).join('>');
        
        // Return in the same format as the original loadTableRow function expects
        return `${yearNumString}|~|${item.watchImage}|~|${item.caseDiameter}|~|${item.lugToLugDistance}|~|${item.lugWidth}|~|${item.watchHeadImage}|~|${articleHandles}|~|${item.recommendedCollection}|~|${item.brand}|~|${item.collection}|~|${item.brandSpecificPage}|~|${item.model}|~|${item.modelLandingPage}|~|${item.identifier}`;
    });
    
    console.log('🔍 Constructed htmlArray for smart search results:', htmlArray);
    
    // Use the existing loadTableRow function to display the results
    var isPageType = $('jsc-watch-finder--drop-down').attr('sfPageType');
    loadTableRow(htmlArray, isPageType);
    
    // Show the year wrapper
    $('jsc-watch-finder-content').addClass('show-year');
    $('jsc-year-wrapper').show();
    $('jsc-year-right-wrapper').show();
    $('jsc-year-reference-img').show();
};

// Function to add watch to session storage for non-logged-in users
addToSessionStorage = (watchData) => {
watchData = sfCanonicalWatchIdentity(watchData);

    let sessionWatches = [];
    
    try {
        const stored = sessionStorage.getItem('sf_session_watches');
        if (stored) {
            sessionWatches = sfCanonicalSavedWatches(JSON.parse(stored));
        }
    } catch (e) {
        console.warn('Error parsing session storage:', e);
        sessionWatches = [];
    }
    
    // Check if watch already exists using brand + collection + reference matching
    const exists = sessionWatches.some(watch => 
        watch.brand === watchData.brand && 
        watch.collection === watchData.collection && 
        watch.reference === watchData.reference
    );
    
    if (!exists) {
        // Enforce 50 watch limit
        if (sessionWatches.length < 50) {
            sessionWatches.push(watchData);
            sessionStorage.setItem('sf_session_watches', JSON.stringify(sessionWatches));
        }
    } 
    
    // Update UI
    updateSessionStorageWatchCollection();
    updateSessionStorageCounters();
    updateStrapFinderTabIcons();
};

// Function to remove watch from session storage for non-logged-in users
removeFromSessionStorage = (watchData, element) => {
watchData = sfCanonicalWatchIdentity(watchData);

    let sessionWatches = [];
    
    try {
        const stored = sessionStorage.getItem('sf_session_watches');
        if (stored) {
            sessionWatches = sfCanonicalSavedWatches(JSON.parse(stored));
        }
    } catch (e) {
        console.warn('Error parsing session storage:', e);
        return;
    }
    
    // Remove the watch using brand + collection + reference matching
    sessionWatches = sessionWatches.filter(watch => 
        !(watch.brand === watchData.brand && 
          watch.collection === watchData.collection && 
          watch.reference === watchData.reference)
    );
    sessionStorage.setItem('sf_session_watches', JSON.stringify(sessionWatches));
    
    // Remove the watch card from DOM if element is provided
    if (element) {
        $(element).closest('.jsc-year-img-item').remove();
    }
    
    // Update UI
    updateSessionStorageWatchCollection();
    updateSessionStorageCounters();
    updateStrapFinderTabIcons();
};

// Function to update session storage counters
updateSessionStorageCounters = () => {
    let sessionWatches = [];
    
    try {
        const stored = sessionStorage.getItem('sf_session_watches');
        if (stored) {
            sessionWatches = sfCanonicalSavedWatches(JSON.parse(stored));
        }
    } catch (e) {
        sessionWatches = [];
    }
    
    if (sessionWatches.length >= 50) {
        $('.sf-saved-watch-error-limit-message').show();
        $('.sf-saved-watch-count-message').hide();
    } else if (sessionWatches.length > 0) {
        $('.sf-saved-watch-error-limit-message').hide();
        $('.sf-saved-watch-count-message').show();
        $('.sf-saved-watch-count-message .sf-saved-watch-count').text(sessionWatches.length);
    } else {
        $('.sf-saved-watch-error-limit-message').hide();
        $('.sf-saved-watch-count-message').hide();
    }
};

// Function to migrate session storage to metafields when user logs in
migrateSessionStorageToMetafields = (retryCount = 0) => {
    const maxRetries = 5;
    const retryDelay = 2000; // 2 seconds
    
    console.log(`🔄 Migration attempt ${retryCount + 1}/${maxRetries + 1}`);
    
    let sessionWatches = [];
    
    try {
        const stored = sessionStorage.getItem('sf_session_watches');
        if (stored) {
            sessionWatches = sfCanonicalSavedWatches(JSON.parse(stored));
        }
    } catch (e) {
        console.warn('Error parsing session storage for migration:', e);
        return;
    }
    
    console.log('📦 Session watches to migrate:', sessionWatches.length);
    
    if (sessionWatches.length === 0) {
        console.log('✅ No session watches to migrate');
        return;
    }
    
    const $watchFinder = $('jsc-watch-finder');
    const customerID = $watchFinder.attr('customer-id');
    const rawWatchList = $watchFinder.attr('customer-save-watch-list');
    const rawTags = $watchFinder.attr('customer-current-tags') || '';
    let existingTags = rawTags.split(',').map(tag => tag.trim()).filter(Boolean);
    
    console.log('🔍 Current metafield data:', rawWatchList);
    console.log('�� Customer ID:', customerID);
    
    // Check if metafields are available (only retry if null/undefined, not if empty string)
    if ((rawWatchList === null || rawWatchList === undefined) && retryCount < maxRetries) {
        console.log(`⏳ Metafields not ready yet, retrying in ${retryDelay}ms... (attempt ${retryCount + 1}/${maxRetries})`);
        setTimeout(() => {
            migrateSessionStorageToMetafields(retryCount + 1);
        }, retryDelay);
        return;
    }
    
    // If max retries reached and metafields still not ready, refresh page as fallback
    if ((rawWatchList === null || rawWatchList === undefined) && retryCount >= maxRetries) {
        console.log('🔄 Max retries reached, refreshing page to ensure metafields are loaded...');
        window.location.reload();
        return;
    }
    
    // Parse existing watches
    let existingWatches = safeParseJSON(rawWatchList, []);
    
    // Merge session storage watches with existing metafield watches
    const mergedWatches = [...existingWatches];
    
    sessionWatches.forEach(sessionWatch => {
        // Check if watch already exists (by brand + collection + reference)
        const exists = existingWatches.length > 0 && existingWatches.some(existing => 
            existing.brand === sessionWatch.brand && 
            existing.collection === sessionWatch.collection && 
            existing.reference === sessionWatch.reference
        );
        if (!exists) {
            mergedWatches.push(sessionWatch);
        }
    });
    
    // Enforce 50 watch limit
    if (mergedWatches.length > 50) {
        mergedWatches.splice(50);
    }
    
    // Update customer tags
    const currentTagSet = new Set();
    mergedWatches.forEach(watch => {
        if (watch.brand) currentTagSet.add(`sf_brand_${watch.brand.toLowerCase()}`);
        if (watch.model) currentTagSet.add(`sf_model_${watch.model.toLowerCase()}`);
        if (watch.collection) currentTagSet.add(`sf_collection_${watch.collection.toLowerCase()}`);
        if (watch.identifier) currentTagSet.add(`sf_id_${watch.identifier.toLowerCase()}`);
        if (watch.reference) currentTagSet.add(`sf_ref_${watch.reference.toLowerCase()}`);
    });
    
    // Handle watch count range tags
    for (let i = 1; i <= 50; i += 5) {
        const upper = Math.min(i + 4, 50);
        currentTagSet.delete(`sf_${i}-${upper}_watches`);
    }
    
    if (mergedWatches.length > 0) {
        const lowerBound = Math.floor((mergedWatches.length - 1) / 5) * 5 + 1;
        const upperBound = Math.min(lowerBound + 4, 50);
        currentTagSet.add(`sf_${lowerBound}-${upperBound}_watches`);
    }
    
    const newTags = Array.from(currentTagSet).filter(tag => !existingTags.includes(tag));
    const updatedTagSet = new Set([...existingTags, ...newTags]);
    
    $watchFinder.attr('customer-current-tags', Array.from(updatedTagSet).join(','));
    
    // Send to webhook
    $.ajax({
        url: "https://webhooks.mechanic.dev/411d70c6-afc5-463b-9db8-583a633f213a",
        method: "POST",
        contentType: "application/json",
        data: JSON.stringify({
            customer_id: customerID,
            watches: mergedWatches,
            tags: Array.from(updatedTagSet)
        }),
    }).done(() => {
        // Clear session storage after successful migration
        sessionStorage.removeItem('sf_session_watches');
        
        // Update the customer-save-watch-list attribute with merged watches
        $watchFinder.attr('customer-save-watch-list', JSON.stringify(mergedWatches));
        
        // Update UI to reflect migrated watches
        const watchList = mergedWatches;
        
        if (watchList && watchList.length >= 50) {
            $('.sf-saved-watch-error-limit-message').show();
            $('.sf-saved-watch-count-message').hide();
        } else if (watchList && watchList.length > 0) {
            $('.sf-saved-watch-error-limit-message').hide();
            $('.sf-saved-watch-count-message').show();
            $('.sf-saved-watch-count-message .sf-saved-watch-count').text(watchList.length);
        } else {
            $('.sf-saved-watch-error-limit-message').hide();
            $('.sf-saved-watch-count-message').hide();
        }
        
        // Update icons in Strap Finder tab
        updateStrapFinderTabIcons();
        
        // Update Watch Collection tab visibility
        const $noWatchesDiv = $('#_jscSavedWatchesList_na');
        const $watchesDiv = $('#_jscSavedWatchesList_display');
        
        if (watchList.length === 0) {
            $noWatchesDiv.show();
            $watchesDiv.hide();
        } else {
            $noWatchesDiv.hide();
            $watchesDiv.show();
        }
        
        // Populate logged-in watches
        updateLoggedInWatchCollection();
    }).fail((error) => {
        console.error("❌ Error migrating session storage:", error);
    });
    
};

// Function to update the Watch Collection tab for non-logged-in users
updateSessionStorageWatchCollection = () => {
    let sessionWatches = [];
    
    try {
        const stored = sessionStorage.getItem('sf_session_watches');
        if (stored) {
            sessionWatches = sfCanonicalSavedWatches(JSON.parse(stored));
        }
    } catch (e) {
        console.warn('Error parsing session storage:', e);
        sessionWatches = [];
    }
    
    const $noWatchesDiv = $('#_jscSavedWatchesList_na');
    const $watchesDiv = $('#_jscSavedWatchesList_display');
    
    if (sessionWatches.length === 0) {
        $noWatchesDiv.show();
        $watchesDiv.hide();
    } else {
        $noWatchesDiv.hide();
        $watchesDiv.show();
        
        // Populate the session storage watches
        const $container = $('#session-storage-watches');
        $container.empty();
        
        sfHydratePersistedBrands(sessionWatches);
        sessionWatches.forEach((watch, index) => {
            const display = sfPersistedWatchDisplay(watch);
            const watchHtml = `
                <div
                    class="jsc-year-img-item cursor columns carousel__slide small-6 medium-6 large-6"
                    data-brand="${watch.brand}"
                    data-model="${watch.model}"
                    data-collection="${watch.collection}"
                    data-identifier="${watch.identifier}"
                    data-reference="${watch.reference}">
                    <div class="product-card-${index + 1} product-card text-left product-card--content-spacing-true product-card--border-false">
                        <a href="${display.url}">
                            <div class="jsc-year-img">
                                <img
                                    class="no-blur product-secondary-image lazyautosizes ls-is-cached lazyloaded"
                                    src="${display.watchImage}"
                                    alt="${display.brand} ${display.collection} ${display.reference}"/>
                            </div>
                        </a>
                        <div class="jsc-sf-product-card-save-watch sf-filled " onclick="removeFromSessionStorage({ brand: '${watch.brand}', model: '${watch.model}', reference: '${watch.reference}', collection: '${watch.collection}', identifier: '${watch.identifier}' }, this)">
                            <div class="sf-save-watch-button">
                                <span class="sf-save-watch-icon">
                                    <img src="https://cdn.shopify.com/s/files/1/0054/9040/9585/files/tick-circle.svg?v=1760404794" width="40" height="40" alt="Saved">
                                </span>
                            </div>
                        </div>
                        <div class="product-card-info" style="background-color: #fff;">
                            <a href="${display.url}">
                                <div class="fontWeight-6" style="font-size: 15px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;max-width: 100%;">${display.model}</div>
                                <div style="margin-top: 10px;font-size: 13px; color: #7E7E7E;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;max-width: 100%;">Reference: ${display.reference}</div>
                            </a>
                        </div>
                    </div>
                </div>
            `;
            $container.append(watchHtml);
        });
    }
};

// Function to update icons in Strap Finder tab for non-logged-in users
updateStrapFinderTabIcons = () => {
    const $watchFinder = $('jsc-watch-finder');
    const customerId = $watchFinder.attr('customer-id');
    
    if (customerId) {
        // For logged-in users, use metafield data
        const customerMetafieldData = $watchFinder.attr('customer-save-watch-list');
        const watchList = safeParseJSON(customerMetafieldData, []);
        
        $('#Watch-Finder--Drawer .sf-panel-content-strap-finder .jsc-sf-product-card-save-watch').each(function() {
            const $saveWatch = $(this);
            const $dataElement = $saveWatch.closest('.columns').find('.jsc-year-img-data');
            const watchBrand = $dataElement.attr('brand');
            const watchCollection = $dataElement.attr('watch');
            const watchReference = $dataElement.attr('year-ref');
            
            const isSaved = watchList.some(watch => 
                watch.brand === watchBrand && 
                watch.collection === watchCollection && 
                watch.reference === watchReference
            );
            
            if (isSaved) {
                // Show tick icon (saved)
                $saveWatch.addClass('sf-filled');
                $saveWatch.find('.sf-save-watch-icon').html('<img src="https://cdn.shopify.com/s/files/1/0054/9040/9585/files/tick-circle.svg?v=1760404794" width="40" height="40" alt="Saved">');
            } else {
                // Show plus icon (not saved)
                $saveWatch.removeClass('sf-filled');
                $saveWatch.find('.sf-save-watch-icon').html('<img src="https://cdn.shopify.com/s/files/1/0054/9040/9585/files/add-circle.svg?v=1760405891" width="40" height="40" alt="Add">');
            }
        });
    } else {
        // For non-logged-in users, use session storage
        let sessionWatches = [];
        try {
            const stored = sessionStorage.getItem('sf_session_watches');
            if (stored) {
                sessionWatches = sfCanonicalSavedWatches(JSON.parse(stored));
            }
        } catch (e) {
            sessionWatches = [];
        }
        
        $('#Watch-Finder--Drawer .sf-panel-content-strap-finder .jsc-sf-product-card-save-watch').each(function() {
            const $saveWatch = $(this);
            const $dataElement = $saveWatch.closest('.columns').find('.jsc-year-img-data');
            const watchBrand = $dataElement.attr('brand');
            const watchCollection = $dataElement.attr('watch');
            const watchReference = $dataElement.attr('year-ref');
            console.log('🔍 updateStrapFinderTabIcons (non-logged-in) - Watch check:', {
                watchBrand,
                watchCollection, 
                watchReference,
                sessionWatchesCount: sessionWatches.length
            });
            const isSaved = sessionWatches.some(watch => 
                watch.brand === watchBrand && 
                watch.collection === watchCollection && 
                watch.reference === watchReference
            );
            
            
            
            if (isSaved) {
                // Show tick icon (saved)
                $saveWatch.addClass('sf-filled');
                $saveWatch.find('.sf-save-watch-icon').html('<img src="https://cdn.shopify.com/s/files/1/0054/9040/9585/files/tick-circle.svg?v=1760404794" width="40" height="40" alt="Saved">');
            } else {
                // Show plus icon (not saved)
                $saveWatch.removeClass('sf-filled');
                $saveWatch.find('.sf-save-watch-icon').html('<img src="https://cdn.shopify.com/s/files/1/0054/9040/9585/files/add-circle.svg?v=1760405891" width="40" height="40" alt="Add">');
            }
        });
    }
};

// Function to populate logged-in user's watch collection
updateLoggedInWatchCollection = () => {
    const $watchFinder = $('jsc-watch-finder');
    const customerMetafieldData = $watchFinder.attr('customer-save-watch-list');
    const watchList = safeParseJSON(customerMetafieldData, []);
    
    console.log('🔄 Updating logged-in watch collection, watch count:', watchList.length);
    
    const $container = $('#logged-in-watches');
    $container.empty();
    
    if (watchList.length === 0) {
        return;
    }
    
    sfHydratePersistedBrands(watchList);
    watchList.forEach((watch, index) => {
        const display = sfPersistedWatchDisplay(watch);
        const watchHtml = `
            <div
                class="jsc-year-img-item cursor columns carousel__slide small-6 medium-6 large-6"
                data-brand="${watch.brand}"
                data-model="${watch.model}"
                data-collection="${watch.collection}"
                data-identifier="${watch.identifier}"
                data-reference="${watch.reference}">
                <div class="product-card-${index + 1} product-card text-left product-card--content-spacing-true product-card--border-false">
                    <a href="${display.url}">
                        <div class="jsc-year-img">
                            <img
                                class="no-blur product-secondary-image lazyautosizes ls-is-cached lazyloaded"
                                src="${display.watchImage}"
                                alt="${display.brand} ${display.collection} ${display.reference}"/>
                        </div>
                    </a>
                    <div class="jsc-sf-product-card-save-watch" onclick="removeFromWatchList({ brand: '${watch.brand}', model: '${watch.model}', reference: '${watch.reference}', collection: '${watch.collection}', identifier: '${watch.identifier}' }, this)">
                        <div class="sf-save-watch-button">
                            <span class="sf-save-watch-icon">
                                <img src="https://cdn.shopify.com/s/files/1/0054/9040/9585/files/tick-circle.svg?v=1760404794" width="40" height="40" alt="Saved">
                            </span>
                        </div>
                    </div>
                    <div class="product-card-info" style="background-color: #fff;">
                        <a href="${display.url}">
                            <div class="fontWeight-6" style="font-size: 15px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;max-width: 100%;">${display.model}</div>
                            <div style="margin-top: 10px;font-size: 13px; color: #7E7E7E;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;max-width: 100%;">Reference: ${display.reference}</div>
                        </a>
                    </div>
                </div>
            </div>
        `;
        $container.append(watchHtml);
    });
};